import { CAMPAIGN_DAILY_LIMIT_MAX, CAMPAIGN_DAILY_LIMIT_MIN, isValidCampaignDailyLimit } from "./campaignDailyLimit";
import { Avatar, Box, Button, Link, Collapse, Chip, FormControl, FormControlLabel, FormGroup, Select, InputLabel, DialogContentText, Divider, Stack, Switch, Typography, Tooltip, Grid2, Alert, TextField, MenuItem, CircularProgress, Paper } from "@mui/material";
import CsvLogo from "@assets/images/csv_logo.svg";
import googleLogo from "@assets/images/google_g_logo.svg";
import GoogleSheetsLogo from "@assets/images/googleSheets.svg";
import HubspotLogo from "@assets/images/hubspot.svg";
import InstantlyLogo from "@assets/images/instantly.svg";
import PipeDrive from "@assets/images/pipedrive.svg";
import SalesforceLogo from "@assets/images/salesforce.svg";
import SmartleadLogo from "@assets/images/smartlead.svg";
import IconButton from "@mui/material/IconButton";
import StatCard from "@components/StatCard";
import { ArrowBack, BarChart, ContactMail, Unsubscribe,  Send, Message, PlayArrow, Pause, PlayCircle, CalendarMonth, Edit, HourglassBottom, Dns, Downloading, ContentCopy as IconCopy } from "@mui/icons-material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import * as React from "react";
import { useEffect, useState, useMemo, useRef } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { ApiRequestFailed, authenticateAndFetchData, authenticateAndPostData, retryFn } from "@lib/apis";
import { useSnackbar } from "notistack";
import PageLoading from "@components/PageLoading";
import PageDataErrorHandler from "@components/PageDataErrorHandler";
import { useDialogs } from "@toolpad/core";
import { ColDef, ValueFormatterParams } from "ag-grid-community";
import PaginatedServerSideDataTable from "@components/PaginatedServerSideDataTable";
import { CustomCellRendererProps } from "ag-grid-react";
import { format } from "date-fns";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import { urls } from "@routes";
import AdminCampaignDailyLog, { useCampaignDailyLog } from "./AdminCampaignDailyLog";
import CloseIcon from '@mui/icons-material/Close';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ReportIcon from '@mui/icons-material/Report';
import ReplyIcon from '@mui/icons-material/Reply';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,	
	InputAdornment,
	Pagination,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CopyButton from "@components/CopyButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { exportToCSV, CSVColumn, GenericCsvExportButton, colDefsToCsvColumns } from "@components/ExportToCSV";
import { getExportFilename } from "@lib/utils";
import {useAuth} from "./AuthProvider";
import { Link as RouterLink } from "react-router-dom";
import GoogleLogo from "@assets/images/google_g_logo.svg"
import MicrosoftLogo from "@assets/images/microsoft.svg"
import YahooLogo from "@assets/images/yahoo.svg"
import ZohoLogo from "@assets/images/zoho.svg"
import OutlookLogo from "@assets/images/outlook.png"

export const LogoMap: Record<string, string> = {
	"CSV": CsvLogo,
	Hubspot: HubspotLogo,
	"Google Sheets": GoogleSheetsLogo,
	Salesforce: SalesforceLogo,
	Instantly: InstantlyLogo,
	Smartlead: SmartleadLogo,
	"Google Postmaster": googleLogo,
	Pipedrive: PipeDrive,
};

export const ESP_LOGOS: Record<string, { src: string; label: string }> = {
	google:    { src: GoogleLogo,    label: "Google" },
	microsoft: { src: MicrosoftLogo, label: "Microsoft" },
	yahoo:     { src: YahooLogo,     label: "Yahoo" },
	zoho:      { src: ZohoLogo,      label: "Zoho" },
	microsoft_consumer:   { src: OutlookLogo, label: "Outlook"},
}


interface PaginationData<T> {
	data: T[];
	total_count: number;
	total_pages: number;
	current_page: number;
	page_size: number;
}

interface SendingDomain {
	id: number;
	subdomain: string;
	status: string;
	warmup_percent: number;
	warmup_days_remaining: number;
}

interface ContactList {
	uid: string;
	name: string;
	status: string;
	source: string;
}

export interface AutoResponseLog {
  uid: string;
  campaign_uid: string | null;
  campaign_title: string | null;
  lead_email: string | null;
  schedule_name: string | null;
  status: string;
  scheduled_at: string | null;
  sent_at: string | null;
  postal_message_id: string | null;
  postal_link: string | null;
  cancellation_reason: string | null;
  created_at: string | null;
  updated_at: string | null;
  reply_type: string | null;
}

interface AutoResponseMessageConfig {
  id: number;
  campaign_id: number;
  campaign_uid: string | null;
  campaign_title: string | null;
  // Positive
  positive_enabled: boolean;
  positive_body: string;
  positive_delay_minutes: number;
  positive_email_content_type: string;
  // Neutral
  neutral_enabled: boolean;
  neutral_body: string;
  neutral_delay_minutes: number;
  neutral_email_content_type: string;
  // Negative
  negative_enabled: boolean;
  negative_body: string;
  negative_delay_minutes: number;
  negative_email_content_type: string;
  // Timestamps
  created_at: string | null;
  updated_at: string | null;
}

const ESP_PROVIDERS = [
	{field: "esp_send_google", botFilterField: "bot_filter_google", label: "Google (Google Workspace & Gmail)"},
	{field: "esp_send_microsoft", botFilterField: "bot_filter_microsoft", label: "Microsoft 365 (custom domains only, not Outlook.com/Hotmail.com)"},
	{field: "esp_send_zoho", botFilterField: "bot_filter_zoho", label: "Zoho Mail"},
	{field: "esp_send_other", botFilterField: "bot_filter_other", label: "Other Providers (Outlook.com, Hotmail.com, Live.com, MSN, Yahoo, AOL, iCloud)"},
] as const;

type EspToggleField = typeof ESP_PROVIDERS[number]["field"];
type BotFilterField = typeof ESP_PROVIDERS[number]["botFilterField"];

// Detection windows are a platform-wide setting on /admin/email-settings; a campaign only chooses
// which providers bot filtering applies to.
const DEFAULT_BOT_FILTER_SETTINGS: Record<BotFilterField, boolean> = {
	bot_filter_google: true,
	bot_filter_microsoft: true,
	bot_filter_zoho: true,
	bot_filter_other: true,
};
export interface VerificationContactList {
    uid: string;
    name: string;
    source: string;
    contacts_count: number;
    email_verification_status: string;
}

export interface VerificationSummary {
    contacts_after_verification?: number;
    dangerous_emails?: number;
    disposable_emails?: number;
    catch_all_emails?: number;
    full_inbox_emails?: number;
    invalid_emails?: number;
    unverifiable_emails?: number;
    webmail_emails?: number;
    contacts_uploaded?: number;
    unverified_emails?: number;
    skipped_emails?: number;
    unsubscribed?: number;
}

interface Campaign {
	// User & Workspace
	user_id: number;
	user_email: string;
	workspace_id: number;
	workspace_name: string;

	// Campaign Identification
	campaign_id: string;
	name: string;
	status: string;
	archived: boolean;

	// Timestamps
	created_on_ts: number | null;
	started_running_at_ts: number | null;
	completed_at_ts: number | null;
	cancelled_at_ts: number | null;
	scheduled_start_datetime_ts: number | null;
	campaign_paused_on_ts: number | null;

	// Email Timing & Limits
	from_time: string;
	to_time: string;
	time_zone: string;
	skip_days: string[];
	daily_email_limit: number;
	emails_per_day: number | null;

	// Email Configuration
	is_html_email: boolean;
	add_unsub_link: boolean;
	unsub_link_type: string;
	custom_unsub_text: string | null;
	single_subject: boolean;
	reply_to_address: string | null;
	test_email_destinations: string | null;

	// Status Flags
	campaign_paused: boolean;
	is_generating_schedules: boolean;
	is_deleting_schedules: boolean;
	is_campaign_bounce_blocked: boolean;

	// Related Data
	sending_domains: SendingDomain[];
	selected_contact_lists: ContactList[];

	// Stats
	total_contacts: number;
	total_schedules: number;
	total_sent: number;
	total_replies: number;
	total_bounced: number;	
	positive_replies?: number;
	negative_replies?: number;
	neutral_replies?: number;
	total_unsubscribe?: number;
	days_campaign_sent?: string[];
	days_campaign_not_sent?: string[];
	scheduling_strategy: string
	scheduling_strategy_display: string
	open_tracking_enabled: boolean
	click_tracking_enabled: boolean
	contact_list_verified: boolean
	total_opens: number
	unique_opens: number
	total_forced_opens: number
	total_clicks: number
	unique_clicks: number
	leads_contacted: number
	completed_at: string | null
	reply_rate: number
	bounce_rate: number
	open_rate: number
	click_rate: number
	esp_send_google: boolean
	esp_send_microsoft: boolean
	esp_send_zoho: boolean
	esp_send_other: boolean
	esp_settings_locked: boolean
	esp_summary: {
		total: number;
		providers: Record<EspToggleField, number>;
		unknown: number;
	}
	bot_filter_enabled: boolean
	bot_filter_google: boolean
	bot_filter_microsoft: boolean
	bot_filter_zoho: boolean
	bot_filter_other: boolean

	// email variant
	campaign_type: string
	is_campaign_ab_cancelled: boolean
	email_verification_status: "queued" | "completed" | "processing" | "skipped" | "failed" | "N/A"
	skip_unverified_emails: boolean
	skip_dangerous_emails: boolean
	skip_disposable_emails: boolean
	skip_catchall_emails: boolean
	skip_full_inbox_emails: boolean
	skip_invalid_emails: boolean
	skip_unverifiable_emails: boolean
	skip_webmail_emails: boolean
	send_to_skipped_emails: boolean
	enable_contact_verification: boolean
	email_verification_contact_lists: VerificationContactList[];
	verification_summary: VerificationSummary;
}

interface CampaignSummaryData {
	status_code: number;
	status_text: string;
	campaign: Campaign;
}

interface CampaignMessage {
	uid: string
	subject: string
	body: string
	next_message_days: number
	spam_score: number
	verdict: string
	suggestions: Array<string>
	text_type: string
}

interface Contacts {
	uid: string
	email_id: string
	attriutes: any
	sending_email: string
}

interface Schedule {
	uid: string
	contact: string
	message_uid: string
	schedule_date_ts: string | null
	status: string
	sent_on_ts: string | null
	aws_message_id: string | null
	email_s3_key: string | null
	reply_received: boolean
	reply_classification: string | null
}

interface GetEstDataResult {
	id: string
	est_days: number
	est_end_date: string
}

export default function AdminUserCampaignDetails() {
	const { userId, campaignUID } = useParams();
	const navigate = useNavigate();
	const dialogs = useDialogs();
	const { user } = useAuth();
	const { enqueueSnackbar } = useSnackbar();

	const [campaignSummary, setCampaignSummary] = useState<CampaignSummaryData>();
	const [openSendDialog, setOpenSendDialog] = useState(false);
	const [selectedMessageUID, setSelectedMessageUID] = useState("");
	const [estDays, setEstDays] = useState<number>(15);
	const [estEndDate, setEstEndDate] = useState<string>("");
	const location = useLocation();
	const backUrlMap: Record<string, string> = {
		AllCampaign: urls["adminAllCampaign"],
		SendingHistory: urls["adminUserSendingHistory"].replace(":userId", userId ?? ""),
	};

	const backUrl = backUrlMap[location.state?.from] ?? `/admin/users/${userId}/campaigns`;

	// State for campaign settings modal
	const [openSettingsModal, setOpenSettingsModal] = useState(false);
	const [settingsForm, setSettingsForm] = useState({
		daily_email_limit: 0,
		from_time: "",
		to_time: "",
		time_zone: "",
		reply_to_address: "",
		archived: false,
		esp_send_google: true,
		esp_send_microsoft: true,
		esp_send_zoho: true,
		esp_send_other: true,
		bot_filter_enabled: true,
		...DEFAULT_BOT_FILTER_SETTINGS,
		skip_unverified_emails: false,
		skip_dangerous_emails: false,
		skip_disposable_emails: false,
		skip_catchall_emails: false,
		skip_full_inbox_emails: false,
		skip_invalid_emails: false,
		skip_unverifiable_emails: false,
		skip_webmail_emails: false,
		send_to_skipped_emails: false,
	});

	// Pagination state for messages
	const [messagesPage, setMessagesPage] = useState(1);
	const [messagesPageSize, setMessagesPageSize] = useState(50);
	const [messagesSearch, setMessagesSearch] = useState("");

	// Pagination state for contacts
	const [contactsPage, setContactsPage] = useState(1);
	const [contactsPageSize, setContactsPageSize] = useState(50);
	const [contactsSearch, setContactsSearch] = useState("");

	// Pagination state for schedules
	const [schedulesPage, setSchedulesPage] = useState(1);
	const [schedulesPageSize, setSchedulesPageSize] = useState(50);
	const [schedulesSearch, setSchedulesSearch] = useState("");

	// Pagination state for Bounces
	const [bouncesPage, setBouncesPage] = useState(1);
	const [bouncesPageSize, setBouncesPageSize] = useState(50);
	const [bouncesSearch, setBouncesSearch] = useState("");
	const [sortField, setSortField] = useState("");
    const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

	// Pagination state for Campaign replies
	const [repliesPage, setRepliesPage] = useState(1);
	const [repliesPageSize, setRepliesPageSize] = useState(50);
	const [repliesSearch, setRepliesSearch] = useState("");
	const [selectedReply, setSelectedReply] = useState<any | null>(null);
	const [replyDialogOpen, setReplyDialogOpen] = useState(false);

	// Pagination state for open events
	const [opensSearch, setOpensSearch] = useState("");
	const [opensPage, setOpensPage] = useState(1);
	const [opensPageSize, setOpensPageSize] = useState(10);
	const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});

	// Pagination state for click events
	const [clicksSearch, setClicksSearch] = useState("");
	const [clicksPage, setClicksPage] = useState(1);
	const [clicksPageSize, setClicksPageSize] = useState(10);

	// Pagination state for Variant events
	const [variantPage, setVariantPage] = useState(1);
	const [variantPageSize, setVariantPageSize] = useState(50);
	const [variantSearch, setVariantSearch] = useState("");

	// Pagination for manual email sent
	const [manualEmailPage, setManualEmailPage] = useState(1);
	const [manualEmailPageSize, setManualEmailPageSize] = useState(50);
	const [manualEmailPageSearch, setManualEmailPageSearch] = useState("");

	// Pagination state for Auto Response events
	const [autoResponsePage, setAutoResponsePage] = useState(1);
	const [autoResponsePageSize, setAutoResponsePageSize] = useState(50);
	const [autoResponseSearch, setAutoResponseSearch] = useState("");

	// Pagination state for Auto Response Message events
	const [autoResponseMessagePage, setAutoResponseMessagePage] = useState(1);
	const [autoResponseMessagePageSize, setAutoResponseMessagePageSize] = useState(50);
	const [autoResponseMessageSearch, setAutoResponseMessageSearch] = useState("");

	// Shares a query key with the daily log table below, so this resolves from cache
	// rather than issuing a second request.
	const dailyLogSummary = useCampaignDailyLog(campaignUID || "").data?.summary;

	// Query to fetch campaign summary
	const campaignSummaryQuery = useQuery({
		queryKey: ["adminCampaignSummary", userId, campaignUID],
		queryFn: () => {
			const params = new URLSearchParams({
				user_id: userId || "",
				campaign_uid: campaignUID || "",
			});
			return authenticateAndFetchData(`/admin/get-campaign-details/?${params.toString()}`);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
	});

	useEffect(() => {
		if (campaignSummaryQuery.data) {
			setCampaignSummary(campaignSummaryQuery.data.data);
			// Populate settings form with current campaign data
			const campaign = campaignSummaryQuery.data.data.campaign;
			setSettingsForm({
				daily_email_limit: Math.min(CAMPAIGN_DAILY_LIMIT_MAX, Math.max(CAMPAIGN_DAILY_LIMIT_MIN, campaign.daily_email_limit)),
				from_time: campaign.from_time,
				to_time: campaign.to_time,
				time_zone: campaign.time_zone,
				reply_to_address: campaign.reply_to_address || "",
				archived: campaign.archived,
				esp_send_google: campaign.esp_send_google ?? true,
				esp_send_microsoft: campaign.esp_send_microsoft ?? true,
				esp_send_zoho: campaign.esp_send_zoho ?? true,
				esp_send_other: campaign.esp_send_other ?? true,
				bot_filter_enabled: campaign.bot_filter_enabled ?? true,
				bot_filter_google: campaign.bot_filter_google ?? true,
				bot_filter_microsoft: campaign.bot_filter_microsoft ?? true,
				bot_filter_zoho: campaign.bot_filter_zoho ?? true,
				bot_filter_other: campaign.bot_filter_other ?? true,
				skip_unverified_emails: Boolean(campaign.skip_unverified_emails),
				skip_dangerous_emails: Boolean(campaign.skip_dangerous_emails),
				skip_disposable_emails: Boolean(campaign.skip_disposable_emails),
				skip_catchall_emails: Boolean(campaign.skip_catchall_emails),
				skip_full_inbox_emails: Boolean(campaign.skip_full_inbox_emails),
				skip_invalid_emails: Boolean(campaign.skip_invalid_emails || campaign.skip_unverified_emails),
				skip_unverifiable_emails: Boolean(campaign.skip_unverifiable_emails),
				skip_webmail_emails: Boolean(campaign.skip_webmail_emails),
				send_to_skipped_emails: Boolean(campaign.send_to_skipped_emails),
			});
		}
	}, [campaignSummaryQuery.data]);

	const getEstValuesQuery = useQuery({
		queryKey: ["getAnalyticsEstValues", campaignSummary?.campaign.campaign_id],
		queryFn: () => authenticateAndFetchData(`/admin/get-strategy-estimate/?campaign_uid=${campaignSummary?.campaign.campaign_id}&strat_id=${campaignSummary?.campaign.scheduling_strategy || ""}&workspace_id=${campaignSummary?.campaign.workspace_id}`),
		gcTime: 0,
		enabled: !!campaignSummary?.campaign.scheduling_strategy,
		retry: retryFn,
		refetchOnWindowFocus: false,
	});
	useEffect(() => {
		if (getEstValuesQuery.data) {
			const data = getEstValuesQuery.data.data as GetEstDataResult;
			setEstDays(data.est_days);
			setEstEndDate(format(new Date(data.est_end_date), "do MMM, yyyy"))
		}
		console.log("getEstValuesQuery.data", getEstValuesQuery.data);
	}, [getEstValuesQuery.data]);
	console.log("estEndDate",estEndDate)
	
	const campaignType = campaignSummary?.campaign?.campaign_type;

	const messagesQuery = useQuery({		
		queryKey: ["adminCampaignMessages", campaignType, campaignUID, messagesPage, messagesPageSize, messagesSearch],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				page: messagesPage.toString(),
				page_size: messagesPageSize.toString(),
				search: messagesSearch,
			});
						
			const endpoint = campaignType === "multi-variant"
				? `/admin/get-campaign-variants/?${params.toString()}`
				: `/admin/get-campaign-messages/?${params.toString()}`;

			return authenticateAndFetchData(endpoint);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID
	});

	const manualEmailSentQuery = useQuery({		
		queryKey: ["adminManualEmailSent", campaignUID, manualEmailPage, manualEmailPageSize, manualEmailPageSearch],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				page: manualEmailPage.toString(),
				page_size: manualEmailPageSize.toString(),
				search: manualEmailPageSearch,
			});
						
			const endpoint = `/admin/manual-email-sent/?${params.toString()}`				

			return authenticateAndFetchData(endpoint);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID
	});

	// Query to fetch contacts
	const contactsQuery = useQuery({
		queryKey: ["adminCampaignContacts", campaignUID, contactsPage, contactsPageSize, contactsSearch],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				page: contactsPage.toString(),
				page_size: contactsPageSize.toString(),
				search: contactsSearch,
			});
			return authenticateAndFetchData(`/admin/get-campaign-contacts/?${params.toString()}`);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID,
	});

	const adminVariantAnalysisQuery = useQuery({
		queryKey: ["adminVariantAnalysis", campaignUID, variantPage, variantPageSize, variantSearch],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				page: variantPage.toString(),
				page_size: variantPageSize.toString(),
				search: variantSearch,
			});
			return authenticateAndFetchData(`/admin/campaign-variant-analysis/?${params.toString()}`);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID,
	});

	// Query to fetch schedules
	const schedulesQuery = useQuery({
		queryKey: ["adminCampaignSchedules", campaignUID, schedulesPage, schedulesPageSize, schedulesSearch],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				page: schedulesPage.toString(),
				page_size: schedulesPageSize.toString(),
				search: schedulesSearch,
			});
			return authenticateAndFetchData(`/admin/get-campaign-schedules/?${params.toString()}`);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID,
	});
	
	// Query to fetch Bounce
	const BouncesQuery = useQuery({
		queryKey: [
			"adminCampaignBounces",
			campaignUID, campaignSummary?.campaign.workspace_id, bouncesPage, bouncesPageSize, bouncesSearch, sortField, sortDirection,
		],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				workspace_id: String(campaignSummary?.campaign.workspace_id || ""),
				page: bouncesPage.toString(),
				page_size: bouncesPageSize.toString(),
				search: bouncesSearch,
				sort_field: sortField,
				sort_direction: sortDirection,
			});

			return authenticateAndFetchData(
				`/admin/get-campaign-bounce-events-v2/?${params.toString()}`
			);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID && !!campaignSummary?.campaign.workspace_id,
		});

	const repliesQuery = useQuery({
		queryKey: [
			"adminCampaignReplies",
			campaignUID,
			campaignSummary?.campaign.workspace_id,
			repliesPage,
			repliesPageSize,
			repliesSearch,
		],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				workspace_id: String(campaignSummary?.campaign.workspace_id || ""),
				page: repliesPage.toString(),
				page_size: repliesPageSize.toString(),
				search: repliesSearch,
			});

			return authenticateAndFetchData(
				`/admin/get-replies-campaign/?${params.toString()}`
			);
		},
		enabled: !!campaignUID && !!campaignSummary?.campaign.workspace_id,
		gcTime: 0,
		refetchOnWindowFocus: false,
		retry: retryFn,
	});

	const opensQuery = useQuery({
		queryKey: [
			"adminOpenEvents",
			campaignUID,
			campaignSummary?.campaign.workspace_id,
			opensPage,
			opensPageSize,
			opensSearch,
		],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				workspace_id: String(campaignSummary?.campaign.workspace_id || ""),
				page: opensPage.toString(),
				page_size: opensPageSize.toString(),
				search: opensSearch,
			});

			return authenticateAndFetchData(
				`/admin/get-campaign-open-events-expand-v2/?${params.toString()}`
			);
		},
		enabled: !!campaignUID && !!campaignSummary?.campaign.workspace_id,
		gcTime: 0,
		refetchOnWindowFocus: false,
		retry: retryFn,
	});


	const clickQuery = useQuery({
		queryKey: [
			"adminClickEvents",
			campaignUID,
			campaignSummary?.campaign.workspace_id,
			clicksPage,
			clicksPageSize,
			clicksSearch,
		],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				workspace_id: String(campaignSummary?.campaign.workspace_id || ""),
				page: clicksPage.toString(),
				page_size: clicksPageSize.toString(),
				search: clicksSearch,
			});

			return authenticateAndFetchData(
				`/admin/get-campaign-click-events-v2/?${params.toString()}`
			);
		},
		enabled: !!campaignUID && !!campaignSummary?.campaign.workspace_id,
		gcTime: 0,
		refetchOnWindowFocus: false,
		retry: retryFn,
	});

	const clickEvents = clickQuery.data?.data?.events || [];
	const clicksTotalCount = clickQuery.data?.data?.total_count || 0;
	const clicksTotalPages = clickQuery.data?.data?.total_pages || 1;

	const adminAutoResponseMessageQuery = useQuery({
		queryKey: ["adminAutoResponseMessage", campaignUID, autoResponseMessagePage, autoResponseMessagePageSize, autoResponseMessageSearch],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				page: autoResponseMessagePage.toString(),
				page_size: autoResponseMessagePageSize.toString(),
				search: autoResponseMessageSearch,
			});
			return authenticateAndFetchData(`/admin/get-auto-response-email-messages/?${params.toString()}`);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID,
	});

	const adminAutoResponseQuery = useQuery({
		queryKey: ["adminAutoResponseAnalysis", campaignUID, autoResponsePage, autoResponsePageSize, autoResponseSearch],
		queryFn: () => {
			const params = new URLSearchParams({
				campaign_uid: campaignUID || "",
				page: autoResponsePage.toString(),
				page_size: autoResponsePageSize.toString(),
				search: autoResponseSearch,
			});
			return authenticateAndFetchData(`/admin/get-auto-response/?${params.toString()}`);
		},
		gcTime: 0,
		retry: retryFn,
		refetchOnWindowFocus: false,
		enabled: !!campaignUID,
	});

	// Mutation to start campaign
	const startCampaignMutation = useMutation({
		mutationKey: ["adminStartCampaign"],
		mutationFn: () => authenticateAndPostData("/admin/start-campaign/", {
			campaign_uid: campaignUID,
		}),
		gcTime: 0,
		retry: retryFn,
		onSuccess: () => {
			enqueueSnackbar("Campaign started successfully", { variant: "success" });
			campaignSummaryQuery.refetch();
		},
		onError: (error: ApiRequestFailed) => {
			console.error(error);
			enqueueSnackbar(error.data.message, { variant: "error" });
		}
	});

	// Mutation to pause campaign
	const pauseCampaignMutation = useMutation({
		mutationKey: ["adminPauseCampaign"],
		mutationFn: () => authenticateAndPostData("/admin/pause-campaign/", {
			campaign_uid: campaignUID,
		}),
		gcTime: 0,
		retry: retryFn,
		onSuccess: () => {
			enqueueSnackbar("Campaign paused successfully", { variant: "success" });
			campaignSummaryQuery.refetch();
		},
		onError: (error: ApiRequestFailed) => {
			console.error(error);
			enqueueSnackbar(error.data.message, { variant: "error" });
		}
	});

	// Mutation to resume campaign
	const resumeCampaignMutation = useMutation({
		mutationKey: ["adminResumeCampaign"],
		mutationFn: () => authenticateAndPostData("/admin/resume-campaign/", {
			campaign_uid: campaignUID,
		}),
		gcTime: 0,
		retry: retryFn,
		onSuccess: () => {
			enqueueSnackbar("Campaign resumed successfully", { variant: "success" });
			campaignSummaryQuery.refetch();
		},
		onError: (error: ApiRequestFailed) => {
			console.error(error);
			enqueueSnackbar(error.data.message, { variant: "error" });
		}
	});

	// Mutation to update campaign settings
	const updateCampaignSettingsMutation = useMutation({
		mutationKey: ["adminUpdateCampaignSettings"],
		mutationFn: (settings: Partial<typeof settingsForm>) => {
			// Only send fields that have values
			const payload: any = { campaign_uid: campaignUID };

			if (settings.daily_email_limit !== undefined) payload.daily_email_limit = settings.daily_email_limit;
			if (settings.from_time) payload.from_time = settings.from_time;
			if (settings.to_time) payload.to_time = settings.to_time;
			if (settings.time_zone) payload.time_zone = settings.time_zone;
			if (settings.reply_to_address !== undefined) payload.reply_to_address = settings.reply_to_address;
			if (settings.archived !== undefined) payload.archived = settings.archived;
			for (const field of ["esp_send_google", "esp_send_microsoft", "esp_send_zoho", "esp_send_other"] as const) {
				if (settings[field] !== undefined) payload[field] = settings[field];
			}
			if (settings.bot_filter_enabled !== undefined) payload.bot_filter_enabled = settings.bot_filter_enabled;
			for (const {botFilterField} of ESP_PROVIDERS) {
				if (settings[botFilterField] !== undefined) payload[botFilterField] = settings[botFilterField];
			}

			// Email Verification settings
			if (settings.skip_invalid_emails !== undefined) {
				payload.skip_invalid_emails = settings.skip_invalid_emails;			
				payload.skip_unverified_emails = settings.skip_invalid_emails;
			} else if (settings.skip_unverified_emails !== undefined) {
				payload.skip_unverified_emails = settings.skip_unverified_emails;
			}
			if (settings.skip_dangerous_emails !== undefined) payload.skip_dangerous_emails = settings.skip_dangerous_emails;
			if (settings.skip_disposable_emails !== undefined) payload.skip_disposable_emails = settings.skip_disposable_emails;
			if (settings.skip_catchall_emails !== undefined) payload.skip_catchall_emails = settings.skip_catchall_emails;
			if (settings.skip_full_inbox_emails !== undefined) payload.skip_full_inbox_emails = settings.skip_full_inbox_emails;
			if (settings.skip_invalid_emails !== undefined) payload.skip_invalid_emails = settings.skip_invalid_emails;
			if (settings.skip_unverifiable_emails !== undefined) payload.skip_unverifiable_emails = settings.skip_unverifiable_emails;
			if (settings.skip_webmail_emails !== undefined) payload.skip_webmail_emails = settings.skip_webmail_emails;
			if (settings.send_to_skipped_emails !== undefined) payload.send_to_skipped_emails = settings.send_to_skipped_emails;

			return authenticateAndPostData("/admin/update-campaign-settings/", payload);
		},
		gcTime: 0,
		retry: retryFn,
		onSuccess: () => {
			enqueueSnackbar("Campaign settings updated successfully", { variant: "success" });
			campaignSummaryQuery.refetch();
			setOpenSettingsModal(false);
		},
		onError: (error: ApiRequestFailed) => {
			console.error(error);
			enqueueSnackbar(error.data.message, { variant: "error" });
		}
	});

	function suggestionsFormatter(params: ValueFormatterParams) {
		return params.value.join("\n");
	}

	const handleSortChange = (field: string, direction: "asc" | "desc" | null) => {
        setSortField(direction ? field : "");
        setSortDirection(direction ?? "asc");
        setBouncesPage(1);
    };

	const getReplyChipColor = (replyClass: string) => {
		switch (replyClass?.toLowerCase()) {
			case "positive":
				return {
					bg: "#DCFCE7",
					color: "#00A63E",
					label: "Positive Reply",
				};

			case "negative":
				return {
					bg: "#FEE2E2",
					color: "#DC2626",
					label: "Negative Reply",
				};

			default:
				return {
					bg: "#E8EDFF",
					color: "#2453FF",
					label: "Neutral Reply",
				};
		}
	};

	const getOrdinalSuffix = (num: number) => {
		const j = num % 10, k = num % 100;
		if (j === 1 && k !== 11) return num + "st";
		if (j === 2 && k !== 12) return num + "nd";
		if (j === 3 && k !== 13) return num + "rd";
		return num + "th";
	};

	const EmailBodyCellRenderer = (props: CustomCellRendererProps) => {
		const [open, setOpen] = useState(false);
		const [viewMode, setViewMode] = useState<"raw" | "html">("raw");
		const iframeRef = useRef<HTMLIFrameElement>(null);

		const bodyContent = props.value || "";

		const handleOpen = () => {
			setViewMode("raw");
			setOpen(true);
		};

		const handleClose = () => setOpen(false);

		useEffect(() => {
			if (viewMode === "html" && iframeRef.current) {
				const doc = iframeRef.current.contentDocument;
				if (doc) {
					doc.open();
					doc.write(`
						<!DOCTYPE html>
						<html>
							<head>
								<style>
									body { 
										font-family: sans-serif; 
										margin: 0; 
										padding: 10px; 
										background-color: white; 
										color: black; 
									}
								</style>
							</head>
							<body>${bodyContent}</body>
						</html>
					`);
					doc.close();
				}
			}
		}, [viewMode, bodyContent, open]);

		const handleCopy = () => {		
			const textToCopy = bodyContent || "";

			if (textToCopy) {
				navigator.clipboard.writeText(textToCopy).then(() => {
					enqueueSnackbar("Message Body Copied!", { variant: "success" });
				});
			}
		};
		
		return (
			<>
				<Button size="small" variant="text" onClick={handleOpen}>
					View
				</Button>

				<BootstrapDialog
					onClose={handleClose}
					open={open}
					fullWidth
					maxWidth="md"
				>
					<DialogTitle sx={{ m: 0, p: 2 }}>
						Message Body
						<IconButton
							onClick={handleClose}
							sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
						>
							<CloseIcon />
						</IconButton>
					</DialogTitle>

					<DialogContent dividers sx={{ p: 0 }}>
						<Box
							sx={{
								backgroundColor: "#ffffff",
								minHeight: "400px",
								maxHeight: "600px",
								display: "flex",
								flexDirection: "column"
							}}
						>
							{viewMode === "html" ? (
								<iframe
									ref={iframeRef}
									title="email-preview"
									style={{
										width: '100%',
										height: '500px',
										border: 'none',
										backgroundColor: 'white'
									}}
								/>
							) : (
								<Box sx={{ p: 2, overflowY: 'auto' }}>
									<Typography
										component="pre"
										sx={{
											whiteSpace: 'pre-wrap',
											wordBreak: 'break-word',
											fontFamily: 'monospace',
											fontSize: '0.875rem',
											color: '#000'
										}}
									>
										{bodyContent}
									</Typography>
								</Box>
							)}
						</Box>
					</DialogContent>

					<DialogActions>
						<Button 
							variant="outlined" 
							startIcon={<IconCopy />}
							onClick={handleCopy}
						>
							Copy
						</Button>
						<Button
							variant={viewMode === "html" ? "contained" : "outlined"}
							onClick={() => setViewMode(viewMode === "html" ? "raw" : "html")}
						>
							{viewMode === "html" ? "View Raw Text" : "View HTML"}
						</Button>
						<Button onClick={handleClose} color="secondary">
							Close
						</Button>
					</DialogActions>
				</BootstrapDialog>
			</>
		);
	};

	function timestampFormatter(params: ValueFormatterParams) {
		if (params.value !== null) {
			return format(new Date(params.value), "do MMM y, HH:mm:ss (xxx)");
		} else {
			return "---"
		}
	}

	const getPostalMessageElement = (
		postalId: string | number | null | undefined, 
		postalLink: string | null | undefined
	) => {	
		if (!postalId) {
			return <span className="text-gray-400 dark:text-gray-500">---</span>;
		}
				
		if (postalLink) {
			return (
				<a 
					href={postalLink} 
					target="_blank" 
					rel="noopener noreferrer" 
					className="font-semibold hover:underline cursor-pointer"
					style={{
						color: 'inherit',
						textDecorationColor: 'inherit'
					}}
				>
					<span className="text-slate-900 dark:text-white">
						{postalId}
					</span>
				</a>
			);
		}
		
		return <span className="text-slate-900 dark:text-white">{postalId}</span>;
	};

	function datetimestampFormatter(value: number | null | undefined) {
		if (!value) {
			return {
				date: "---",
				time: "---",
			};
		}

		return {
			date: format(new Date(value), "do MMM y"),
			time: format(new Date(value), "HH:mm:ss (xxx)"),
		};
	}

	const ScheduleStatusCell = (cellProps: CustomCellRendererProps) => {
		switch (cellProps.value) {
			case "created":
				return <Chip label={"Email Created"} size={"small"} color={"default"} variant={"filled"} />;

			case "scheduled":
				return <Chip label={"Scheduled"} size={"small"} color={"primary"} variant={"filled"} />;

			case "sent":
				return <Chip label={"Email Sent"} size={"small"} color={"primary"} variant={"filled"} />;

			case "failed":
				return <Chip label={"Failed"} size={"small"} color={"error"} variant={"filled"} />;

			case "replied":
				return <Chip label={"Reply Received"} size={"small"} color={"success"} variant={"filled"} />;

			case "cancelled_reply_received":
				return <Chip label={"Sequence Complete"} size={"small"} color={"success"} variant={"outlined"} />;

			case "cancelled_unsubscribed":
				return <Chip label={"Unsubscribed"} size={"small"} color={"warning"} variant={"outlined"} />;

			case "cancelled_campaign_stopped":
				return <Chip label={"Cancelled"} size={"small"} color={"error"} variant={"outlined"} />;

			case "cancelled_bad_email":
				return <Chip label={"Bad Email"} size={"small"} color={"error"} variant={"outlined"} />;

			case "cancelled_sequence_stopped":
				return <Chip label={"Sequence Stopped"} size={"small"} color={"default"} variant={"outlined"} />;

			case "cancelled_esp_blocked":
				return <Chip label={"Skipped - ESP Off"} size={"small"} color={"warning"} variant={"outlined"} />;

			default:
				return <Chip label={"N/A"} size={"small"} color={"default"} variant={"filled"} />;
		}
	}

	// Helper function to format timestamps
	function formatTimestamp(ts: number | null): string {
		if (!ts) return "---";
		return format(new Date(ts), "do MMM y, h:mm a");
	}

	// Helper function to get campaign status color
	function getCampaignStatusColor(status: string): "default" | "primary" | "success" | "error" | "warning" {
		switch (status) {
			case "running":
				return "primary";
			case "complete":
				return "success";
			case "cancelled":
				return "error";
			case "paused":
				return "warning";
			case "scheduled":
				return "primary";
			default:
				return "default";
		}
	}

	// Campaign action button components
	const StartCampaignButton = () => (
		<Button
			variant="contained"
			color="success"
			size="small"
			startIcon={<PlayArrow />}
			disabled={startCampaignMutation.isPending || !["created", "scheduled"].includes(campaignSummary?.campaign.status || "")}
			onClick={async () => {
				const confirmed = await dialogs.confirm(
					"Are you sure you want to start this campaign?",
					{ title: "Start Campaign", okText: "Start", cancelText: "Cancel" }
				);
				if (confirmed) startCampaignMutation.mutate();
			}}
		>
			{startCampaignMutation.isPending ? "Starting..." : "Start"}
		</Button>
	);

	const PauseCampaignButton = () => (
		<Button
			variant="outlined"
			color="warning"
			size="small"
			startIcon={<Pause />}
			disabled={pauseCampaignMutation.isPending || campaignSummary?.campaign.status !== "running"}
			onClick={async () => {
				const confirmed = await dialogs.confirm(
					"Are you sure you want to pause this campaign?",
					{ title: "Pause Campaign", okText: "Pause", cancelText: "Cancel" }
				);
				if (confirmed) pauseCampaignMutation.mutate();
			}}
		>
			{pauseCampaignMutation.isPending ? "Pausing..." : "Pause"}
		</Button>
	);

	const ResumeCampaignButton = () => (
		<Button
			variant="contained"
			color="primary"
			size="small"
			startIcon={<PlayCircle />}
			disabled={resumeCampaignMutation.isPending || campaignSummary?.campaign.status !== "paused"}
			onClick={async () => {
				const confirmed = await dialogs.confirm(
					"Are you sure you want to resume this campaign?",
					{ title: "Resume Campaign", okText: "Resume", cancelText: "Cancel" }
				);
				if (confirmed) resumeCampaignMutation.mutate();
			}}
		>
			{resumeCampaignMutation.isPending ? "Resuming..." : "Resume"}
		</Button>
	);

	const EditSettingsButton = () => (
		<Button
			variant="outlined"
			color="info"
			size="small"
			startIcon={<Edit />}
			onClick={() => setOpenSettingsModal(true)}
		>
			Edit Settings
		</Button>
	);

	const emailMessagesColumnCustomizerLabel = {
		uid: "Message UID",
		subject: "Subject",
		body: "Body Message",
		next_message_days: "Next Message Days",
		spam_score: "Spam Score",
		verdict: "Verdict",
		suggestions: "Suggestions",
	};

	// Columns for email messages table.
	const emailMessagesColumnDefs = useMemo<ColDef[]>(() => {
		const isMultiVariant = campaignType === "multi-variant";
		const columns: ColDef[] = [];

		// 1. Conditionally push both tracking columns or stick to standard message identifier
		if (isMultiVariant) {
			columns.push(
				{ field: "message_uid", headerName: "Message UID" },
				{ field: "variant_uid", headerName: "Variant UID" },
				{ field: "display_name", headerName: "Variant Name" }
			);
		} else {
			columns.push(
				{ field: "uid", headerName: "Message UID" }
			);
		}

		columns.push(
			{ field: "subject", headerName: "Subject" },
			{ field: "body", headerName: "Body Message", cellRenderer: EmailBodyCellRenderer },
			{ field: "next_message_days", headerName: "Next Message Days" },
			{ field: "spam_score", headerName: "Spam Score" },
			{ field: "text_type", headerName: "Text Type" },
			{ field: "verdict", headerName: "Verdict" },
			{ field: "suggestions", headerName: "Suggestions", valueFormatter: suggestionsFormatter }
		);
		
		if (isMultiVariant) {
			columns.push({
				field: "is_enabled",
				headerName: "Enabled",
				cellRenderer: (params: any) => (params.value ? "Yes" : "No"),
			});
		}
		
		columns.push({
			field: "test_email",
			headerName: "",
			sortable: false,
			filter: false,
			flex: 2,
			resizable: false,
			cellRenderer: (params: any) => {
				return (
					<Button
						variant="outlined"
						size="small"
						onClick={() => {
							console.log("params", params.data.uid);
							setSelectedMessageUID(params.data.uid);
							setOpenSendDialog(true);
						}}
					>
						Send Test Email
					</Button>
				);
			}
		});

		return columns;
	}, [campaignType]);

	const manualEmailSentColumnCustomizerLabel = {		
		sender: "Sender Email",
		sender_name: "Sender Name",
		receiver: "Recipient Email",
		subject: "Subject",
		cc_emails: "CC",
		time_of_email_sent: "Sent On",
		postal_message_id: "Postal Message ID",
	};

		// Columns for manual email sent table.
	const manualEmailSentColumnDefs: ColDef[] = [		
		{ field: "sender", headerName: "Sender Email" },
		{ field: "sender_name", headerName: "Sender Name" },
		{ field: "receiver", headerName: "Recipient Email" },
		{ field: "subject", headerName: "Subject" },
		{ field: "time_of_email_sent", headerName: "Sent On", valueFormatter: timestampFormatter, resizable: false },
	];

	const contactsColumnCustomizerLabel = {
		uid: "Contact UID",
		email_id: "Email Address",
		attributes: "Variables",
		sending_email: "Sending Email",
	};

	// Columns for contacts table.
	const contactsColumnDefs: ColDef[] = [
		{ field: "uid", headerName: "Contact UID" },
		{ field: "email_id", headerName: "Email Address" },
		{ field: "attributes", headerName: "Variables" },
		{ field: "sending_email", headerName: "Sending Email", resizable: false },
	]

	const schedulesColumnCustomizerLabel = {
		uid: "Schedule UID",
		contact: "Contact",
		message_uid: "Message UID",
		schedule_date_ts: "Scheduled For",
		sent_on_ts: "Sent On",
		aws_message_id: "AWS Msg ID",
		email_s3_key: "Reply S3 Key",
		reply_received: "Reply Received",
		reply_classification: "Reply Class",
		status: "Status",
	};

	// Columns for schedules table.
	const schedulesColumnDefs = useMemo<ColDef[]>(() => {
		const isMultiVariant = campaignType === "multi-variant";
		
		const columns: ColDef[] = [
			{
				field: "esp",
				headerName: "ESP",
				width: 50,
				cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
				cellRenderer: (params: any) => {
					const esp = (params.data?.esp ?? "Unknown").toLowerCase();

					const logo = ESP_LOGOS[esp];
					console.log("ESP_LOGOS", ESP_LOGOS)
					console.log("esp ", esp)
					console.log("logo", logo)

					if (!logo) {
						const label =
							esp === "other" || esp === "others"
								? "Others"
								: "Unknown";

						return (
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									height: "100%",
									width: "100%",
								}}
							>
								<span className="text-xs text-muted-foreground">
									{label}
								</span>
							</Box>
						);
					}

					return (
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								height: "100%",
								width: "100%",
							}}
						>
							<Tooltip title={logo.label} arrow>
								<img
									src={logo.src}
									alt={logo.label}
									style={{
										width: esp === "zoho" ? 24 : 20,
										height: esp === "zoho" ? 24 : 20,
										display: "block",
										objectFit: "contain",
									}}
								/>
							</Tooltip>
						</Box>
					);
				},
			},
			{ field: "uid", headerName: "Schedule UID" },
			{ field: "contact", headerName: "Contact" },
			{ field: "message_uid", headerName: "Message UID" },
		];
		
		if (isMultiVariant) {
			columns.push(
				{ field: "variant_uid", headerName: "Variant UID" },
				{ field: "display_name", headerName: "Variant Name" }
			);
		}
		
		columns.push(
			{ field: "schedule_date_ts", headerName: "Scheduled For", valueFormatter: timestampFormatter },
			{ field: "sent_on_ts", headerName: "Sent On", valueFormatter: timestampFormatter },
			{ field: "aws_message_id", headerName: "AWS Msg ID" },
			{ field: "postal_id", headerName: "Postal Message ID", cellRenderer: (params: any) => {
			return getPostalMessageElement(params.value, params.data?.postal_link);
			}
		},
		{ field: "email_s3_key", headerName: "Reply S3 Key" },
			{ field: "reply_received", headerName: "Reply Received" },
			{ field: "reply_classification", headerName: "Reply Class" },
			{ field: "status", headerName: "Status", cellRenderer: ScheduleStatusCell },
			{
				field: "action", 
				headerName: "Action", 
				resizable: false,
				cellRenderer: (params: any) => {
					if (params.data?.email_s3_key) {
						return (
							<ViewReply
								replyFrom={params.data.contact}
								s3key={params.data.email_s3_key}
							/>
						);
					}
					return null;
				},
			}
		);

		return columns;
	}, [campaignType]);

	const BouncesColumnCustomizerLabel = {
		activity: "Activity",						
	};

	const bounceColumnDefs: ColDef[] = [
		{
			field: "esp",
			headerName: "ESP",
			width: 50,
			cellRenderer: (params: any) => {
				const esp = (params.data?.esp ?? "Unknown").toLowerCase();

				const logo = ESP_LOGOS[esp];

				if (!logo) {
					const label =
						esp === "other" || esp === "others"
							? "Others"
							: "Unknown";

					return (
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								height: "100%",
								width: "100%",
							}}
						>
							<span className="text-xs text-muted-foreground">
								{label}
							</span>
						</Box>
					);
				}

				return (
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							height: "100%",
							width: "100%",
						}}
					>
						<Tooltip title={logo.label} arrow>
							<img
								src={logo.src}
								alt={logo.label}
								style={{
									width: esp === "zoho" ? 24 : 20,
									height: esp === "zoho" ? 24 : 20,
									display: "block",
									objectFit: "contain",
								}}
							/>
						</Tooltip>
					</Box>
				);
			},
		},
		{
			field: "activity.email",
			headerName: "Activity",
			flex: 2,
			cellRenderer: (params: any) => (
			<Box
				sx={{
				display: "flex",
				alignItems: "center",
				height: "100%",
				}}
			>
				<Typography
				component="span"
				sx={{
					fontWeight: 600,
					fontSize: "15px",
					color: "text.primary",
				}}
				>
				{params.data?.activity?.email}
				</Typography>
			</Box>
			),
			sortable: false,
		},
		{
			colId: "timestamp",
			field: "activity.timestamp",
			headerName: "Date & Time",
			flex: 1.5,
			sortable: true,
			valueFormatter: (params: any) => {
				const timestamp = params.value ?? params.data?.activity?.timestamp;
				if (!timestamp) return "-";
				const { date, time } = datetimestampFormatter(timestamp);
				return `${date} • ${time}`;
			},
			cellRenderer: (params: any) => {
			const timestamp = params.data?.activity?.timestamp;
			if (!timestamp) return "-";

			const { date, time } = datetimestampFormatter(timestamp);

			return (
				<Box
				sx={{
					display: "flex",
					alignItems: "center",
					height: "100%",
				}}
				>
				<Typography
					component="span"
					sx={{
					fontSize: "13px",
					color: "text.secondary",
					}}
				>
					{date} • {time}
				</Typography>
				</Box>
			);
			},
		},
		{
			field: "reason",
			headerName: "Reason from Postal",
			flex: 2.5,
			sortable: false,
			cellRenderer: (params: any) => {
			const rawReason = params.data?.raw_reason || params.value || "";

			return (
				<Tooltip title={rawReason} arrow placement="top">
				<Box
					sx={{
					display: "flex",
					alignItems: "center",
					height: "100%",
					width: "100%",
					overflow: "hidden",
					}}
				>
					<Typography
					component="span"
					sx={{
						fontSize: "14px",
						color: "text.primary",
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
						cursor: "pointer",
					}}
					>
					{params.value || "-"}
					</Typography>
				</Box>
				</Tooltip>
			);
			},
		},
		{
			field: "postal_message_id",
			headerName: "Postal Message ID",
			flex: 1.2,
			sortable: false,
			valueFormatter: (params: any) => {
				const msgId = params.value;
				const link = params.data?.postal_link;

				if (msgId && link) {
					return `=HYPERLINK("${link}", "${msgId}")`;
				}
				return msgId || "";
			},
			cellRenderer: (params: any) => {
			return getPostalMessageElement(params.value, params.data?.postal_link);
			},
		},
		];

	const VariantColumnCustomizerLabel = {
		uid: "Variant UID",
		variant_name: "Variant Name",
		subject: "Subject",
		body: "Body Message",
		sent_count: "Emails Sent",
		open_count: "Opens",
		click_count: "Clicks",
		reply_count: "Replies",
		is_enabled: "Enabled",				
	};
	
	const variantAnalysisColumnDefs = useMemo<ColDef[]>(() => [
		{ 
			field: "uid", 
			headerName: "Variant UID", 
			minWidth: 120 
		},
		{ 
			field: "variant_name", 
			headerName: "Variant Name", 
			minWidth: 150, 
			cellStyle: { fontWeight: 600 } 
		},
		{ 
			field: "subject", 
			headerName: "Subject", 
			minWidth: 200 
		},
		{ 
			field: "body", 
			headerName: "Body Message", 
			minWidth: 250, 
			flex: 1,
			cellRenderer: EmailBodyCellRenderer
		},
		{ 
			field: "sent_count", 
			headerName: "Emails Sent", 
			type: "numericColumn", 
			width: 120 
		},
		{ 
			field: "open_count", 
			headerName: "Opens", 
			type: "numericColumn", 
			width: 100 
		},
		{ 
			field: "click_count", 
			headerName: "Clicks", 
			type: "numericColumn", 
			width: 100 
		},
		{ 
			field: "reply_count", 
			headerName: "Replies", 
			type: "numericColumn", 
			width: 100 
		},
		{
			field: "is_enabled",
			headerName: "Enabled",
			width: 110,
			cellRenderer: (params: any) => (params.value ? "Yes" : "No"),
		}
	], []);

	const repliesCsvColumns: CSVColumn<any>[] = [
		{
			header: "Sequence",
			accessor: (row) =>
				row.sequence_number !== undefined
					? Number(row.sequence_number) + 1
					: "",
		},
		{
			header: "Variant",
			accessor: (row) => row.variant_name || "",
		},
		{
			header: "Recipient Email",
			accessor: (row) => row.sender_email || "",
		},
		{
			header: "Sender Email",
			accessor: (row) => row.recipient || "",
		},
		{
			header: "Schedule Uid",
			accessor: (row) => row.schedule_uid || "",
		},
		{
			header: "Reply Text",
			accessor: (row) => row.plain_text_body || "",
		},
		{
			header: "Reply Category",
			accessor: (row) => row.reply_class || "",
		},
		{
			header: "Received Date",
			accessor: (row) =>
				row.received_on
					? format(new Date(row.received_on), "yyyy-MM-dd HH:mm:ss")
					: "",
		},
		{
			header: "Postal ID",
			accessor: (row) =>
				row.postal_id && row.postal_link
					? `=HYPERLINK("${row.postal_link}", "${row.postal_id}")`
					: row.postal_id || "",
		},
	];

	const openEventsCsvColumns = [
		{
			header: "Contact Email",
			accessor: (row) => row.contact_email || "",
		},
		{
			header: "Sequence",
			accessor: (row) =>
				row.sequence_number !== undefined && row.sequence_number !== null
					? Number(row.sequence_number) + 1
					: "",
		},
		{
			header: "Variant",
			accessor: (row) => row.variant_name || "",
		},
		{
			header: "Total Opens",
			accessor: (row) => row.total_opens ?? 0,
		},
		{
			header: "Total Forced Opens",
			accessor: (row) => row.total_forced_opens ?? 0,
		},
		{
			header: "Latest Date",
			accessor: (row) =>
				row.latest_date
					? format(new Date(row.latest_date), "yyyy-MM-dd HH:mm:ss")
					: "",
		},
		{
			header: "Postal Message ID",
			accessor: (row) =>
				row.postal_message_id && row.postal_link
					? `=HYPERLINK("${row.postal_link}", "${row.postal_message_id}")`
					: row.postal_message_id || "",
		},
	];

	// ----------------------------------------------------------------------
	// Click Events CSV Columns
	// ----------------------------------------------------------------------
	const clickEventsCsvColumns = [
		{
			header: "Contact Email",
			accessor: (row) => row.contact_email || "",
		},
		{
			header: "Sequence",
			accessor: (row) =>
				row.sequence_number !== undefined && row.sequence_number !== null
					? Number(row.sequence_number) + 1
					: "",
		},
		{
			header: "Variant",
			accessor: (row) => row.variant_name || "",
		},
		{
			header: "Total Clicks",
			accessor: (row) => row.total_clicks ?? 0,
		},
		{
			header: "Clicked Links Summary",
			accessor: (row) => row.links_summary || "",
		},
		{
			header: "Latest Date",
			accessor: (row) =>
				row.latest_date
					? format(new Date(row.latest_date), "yyyy-MM-dd HH:mm:ss")
					: "",
		},
		{
			header: "Postal Message ID",
			accessor: (row) =>
				row.postal_message_id && row.postal_link
					? `=HYPERLINK("${row.postal_link}", "${row.postal_message_id}")`
					: row.postal_message_id || "",
		},
	];

	const AutoResponseColumnCustomizerLabel = {
		lead_email: "Lead Email",
		campaign_title: "Campaign Title",
		schedule_name: "Schedule Name",
		status: "Status",
		postal_message_id: "Postal Message ID",
		scheduled_at: "Scheduled At",
		sent_at: "Sent At",
		created_at: "Created On",
		};

	// Status Chip color helper
	const getStatusChipColor = (status: string) => {
		switch (status?.toLowerCase()) {
			case "sent":
			case "completed":
			return "success";
			case "pending":
			case "scheduled":
			return "warning";
			case "cancelled":
			case "failed":
			return "error";
			default:
			return "default";
		}
	};

	console.log("adminAutoResponseQuery ", adminAutoResponseQuery.data?.data)
	// Column Definitions for AG-Grid Table
	const AutoResponseColumnDefs: ColDef[] = [
		{ field: "lead_email", headerName: "Lead Email", flex: 1.5, valueFormatter: (params) => params.value || "-" },
		// { field: "campaign_title", headerName: "Campaign Title", flex: 1.5, valueFormatter: (params) => params.value || "-" },
		{ field: "schedule_name", headerName: "Schedule Name", flex: 1.2, valueFormatter: (params) => params.value || "-" },
		{
			field: "status",
			headerName: "Status",
			flex: 1,
			cellRenderer: (params: any) => (
			<Chip
				label={params.value || "Unknown"}
				size="small"
				color={getStatusChipColor(params.value)}
				variant="outlined"
			/>
			),
		},		
		{
			field: "reply_type",
			headerName: "Response Type",
			flex: 1,
			cellRenderer: (params: any) => {
			const type = params.value || "positive";
			//   const colorMap: Record<string, "success" | "info" | "warning" | "default"> = {
			//     positive: "success",
			//     neutral: "info",
			//     negative: "warning",
			//   };

			return (
				<span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
			);
			},
		},
		{
			field: "cancellation_reason",
			headerName: "Failed reason",
			flex: 1,
			cellRenderer: (params: any) => {
			const type = params.value || "N/A";			

			return (
				<span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
			);
			},
		},
		{
			field: "postal_message_id",
			headerName: "Postal Message ID",
			flex: 1.5,
			cellRenderer: (params: any) => {
			const messageId = params.value;
			const postalLink = params.data?.postal_link;

			if (!messageId) return "-";

			if (postalLink) {
				return (
				<Link
					href={postalLink}
					target="_blank"
					rel="noopener noreferrer"
					underline="hover"
					color="primary"
					sx={{ fontWeight: 500 }}
				>
					{messageId}
				</Link>
				);
			}

			return messageId;
			},
		},
		{
			field: "scheduled_at",
			headerName: "Scheduled At",
			flex: 1.2,
			valueFormatter: (params) => {
				// Guard against undefined, empty string, or invalid date values
				if (!params.value || isNaN(Date.parse(params.value))) {
					return "---";
				}
				return timestampFormatter(params);
			},
		},
		{
			field: "sent_at",
			headerName: "Sent At",
			flex: 1.2,
			valueFormatter: (params) => {
				if (!params.value || isNaN(Date.parse(params.value))) {
					return "---";
				}
				return timestampFormatter(params);
			},
		},
		{
			field: "created_at",
			headerName: "Created On",
			flex: 1.2,
			valueFormatter: (params) => {
				if (!params.value || isNaN(Date.parse(params.value))) {
					return "---";
				}
				return timestampFormatter(params);
			},
		},
		];

	// CSV Export Columns Definition
	const autoResponseCsvColumns: CSVColumn<AutoResponseLog>[] = [
		{ header: "Lead Email", accessor: (row) => row.lead_email || "" },
		{ header: "Campaign Title", accessor: (row) => row.campaign_title || "" },
		{ header: "Schedule Name", accessor: (row) => row.schedule_name || "" },
		{ header: "Status", accessor: (row) => row.status || "" },
		{ header: "Response Type", accessor: (row) => row.reply_type || "" },
		{ header: "Postal Message ID", accessor: (row) => row.postal_message_id || "" },
		{ header: "Postal Link", accessor: (row) => row.postal_link || "" },
		{ header: "Scheduled At", accessor: (row) => row.scheduled_at || "" },
		{ header: "Sent At", accessor: (row) => row.sent_at || "" },
		{ header: "Cancellation Reason", accessor: (row) => row.cancellation_reason || "" },
		{ header: "Created On", accessor: (row) => row.created_at || "" },
	];

	const ExportAutoResponseCsvButton = () => {
		const [exportLoading, setExportLoading] = useState(false);
		const { enqueueSnackbar } = useSnackbar();

		const handleExportAutoResponses = async () => {
			setExportLoading(true);

			try {
			const response = await authenticateAndFetchData(
				`/admin/get-auto-response/?export_all=true&search=${encodeURIComponent(
				autoResponseSearch || ""
				)}${campaignUID ? `&campaign_uid=${campaignUID}` : ""}`
			);

			const logsToExport = response?.data?.data || response?.data?.results || [];

			if (!logsToExport.length) {
				enqueueSnackbar("No auto response data available to export.", { variant: "error" });
				return;
			}

			const success = exportToCSV(
				logsToExport,
				autoResponseCsvColumns,
				`auto_response_logs.csv`
			);

			if (success) {
				enqueueSnackbar("Auto response logs exported successfully!", { variant: "success" });
			} else {
				enqueueSnackbar("Failed to generate CSV file.", { variant: "error" });
			}
			} catch (err) {
			console.error("Export error:", err);
			enqueueSnackbar("Error while exporting auto response logs.", { variant: "error" });
			} finally {
			setExportLoading(false);
			}
		};

		return (
			<Button
			variant="contained"
			color="primary"
			startIcon={<Downloading />}
			onClick={handleExportAutoResponses}
			disabled={exportLoading}
			>
			{exportLoading ? "Exporting..." : "Export"}
			</Button>
		);
	};

	const AutoResponseMessageColumnCustomizerLabel = {
  campaign_title: "Campaign Title",
  type: "Response Type",
  is_enabled: "Is Enabled",
  delay_minutes: "Delay (min)",
  content_type: "Content Type",
  body: "Body Message",
  updated_at: "Last Updated",
};

const AutoResponseMessageColumnDefs: ColDef[] = [
//   {
//     field: "campaign_title",
//     headerName: "Campaign Title",
//     flex: 1.5,
//     valueFormatter: (params) => params.value || "-",
//   },
  {
    field: "type",
    headerName: "Response Type",
    flex: 1,
    cellRenderer: (params: any) => {
      const type = params.value || "positive";
    //   const colorMap: Record<string, "success" | "info" | "warning" | "default"> = {
    //     positive: "success",
    //     neutral: "info",
    //     negative: "warning",
    //   };

      return (
        <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
      );
    },
  },
  {
    field: "is_enabled",
    headerName: "Status",
    flex: 1,
    cellRenderer: (params: any) => {
      const isEnabled = Boolean(params.value);
      return (
        <Chip
          label={isEnabled ? "Active" : "Disabled"}
          size="small"
          color={isEnabled ? "success" : "default"}
          variant="outlined"
        />
      );
    },
  },
  {
    field: "delay_minutes",
    headerName: "Delay (min)",
    flex: 0.8,
    valueFormatter: (params) => (params.value !== undefined && params.value !== null ? `${params.value} mins` : "-"),
  },
  {
    field: "content_type",
    headerName: "Content Type",
    flex: 1,
    valueFormatter: (params) => params.value || "-",
  },
  {
    field: "body",
    headerName: "Body Message",
    flex: 1,
    cellRenderer: EmailBodyCellRenderer,
  },
  {
    field: "updated_at",
    headerName: "Last Updated",
    flex: 1.2,
    valueFormatter: timestampFormatter,
  },
];

	const autoResponseMessageCsvColumns: CSVColumn<any>[] = [
  { header: "Campaign Title", accessor: (row) => row.campaign_title || "" },
  { header: "Response Type", accessor: (row) => row.type || "" },
  { header: "Is Enabled", accessor: (row) => (row.is_enabled ? "Yes" : "No") },
  { header: "Delay (min)", accessor: (row) => row.delay_minutes ?? 0 },
  { header: "Content Type", accessor: (row) => row.content_type || "" },
  { header: "Body Message", accessor: (row) => row.body || "" },
  { header: "Updated At", accessor: (row) => row.updated_at || "" },
];

	const ExportAutoResponseMessageCsvButton = () => {
		const [exportLoading, setExportLoading] = useState(false);
		const { enqueueSnackbar } = useSnackbar();

		const handleExportAutoResponseMessages = async () => {
			setExportLoading(true);

			try {
			const response = await authenticateAndFetchData(
				`/admin/get-auto-response-email-messages/?export_all=true&search=${encodeURIComponent(
				autoResponseMessageSearch || ""
				)}${campaignUID ? `&campaign_uid=${campaignUID}` : ""}`
			);

			const messagesToExport = response?.data?.data || response?.data?.results || [];

			if (!messagesToExport.length) {
				enqueueSnackbar("No message configuration data available to export.", { variant: "error" });
				return;
			}

			const success = exportToCSV(
				messagesToExport,
				autoResponseMessageCsvColumns,
				`auto_response_message_configs.csv`
			);

			if (success) {
				enqueueSnackbar("Message configurations exported successfully!", { variant: "success" });
			} else {
				enqueueSnackbar("Failed to generate CSV file.", { variant: "error" });
			}
			} catch (err) {
			console.error("Export error:", err);
			enqueueSnackbar("Error while exporting message configurations.", { variant: "error" });
			} finally {
			setExportLoading(false);
			}
		};

	return (
		<Button
			variant="contained"
			color="primary"
			startIcon={<Downloading />} 
			onClick={handleExportAutoResponseMessages}
			>
			{exportLoading ? "Exporting..." : "Export"}
		</Button>
		);
	};

	// ============================================================
	// --------------------- MAIN RENDER CODE ---------------------
	// ============================================================

	if (campaignSummaryQuery.isLoading) {
		return (
			<PageLoading />
		)

	} else if (campaignSummaryQuery.error as unknown as ApiRequestFailed) {
		return <PageDataErrorHandler error={campaignSummaryQuery.error as unknown as ApiRequestFailed} />

	} else if (campaignSummary) {
		return (
			<Stack direction={"column"} spacing={2} sx={{ pb: 4 }}>
				{/* Header with action buttons */}
				<Stack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"space-between"} flexWrap={"wrap"}>
					<Stack direction={"row"} spacing={2} alignItems={"center"}>
						<IconButton onClick={() => navigate(backUrl)}><ArrowBack /></IconButton>
						<Typography fontWeight={"bold"} variant={"h5"}>
							{campaignSummary.campaign.name}
						</Typography>
						<Chip
							label={campaignSummary.campaign.status}
							color={getCampaignStatusColor(campaignSummary.campaign.status)}
							size="small"
						/>
					</Stack>

					<Stack direction={"row"} spacing={1}>
						<StartCampaignButton />
						<PauseCampaignButton />
						<ResumeCampaignButton />
						<EditSettingsButton />
					</Stack>
				</Stack>
				<Divider />

				<Stack direction={"column"} spacing={4}>
					{/* Status Alerts */}
					{campaignSummary.campaign.is_generating_schedules && (
						<Alert severity="info">
							Campaign schedules are being generated. Please wait...
						</Alert>
					)}
					{campaignSummary.campaign.is_deleting_schedules && (
						<Alert severity="warning">
							Campaign schedules are being deleted. Please wait...
						</Alert>
					)}
					{campaignSummary.campaign.is_campaign_bounce_blocked && (
						<Alert severity="error">
							Campaign is blocked due to high bounce rate!
						</Alert>
					)}
					{campaignSummary.campaign.campaign_paused && (
						<Alert severity="warning">
							Campaign is paused since {formatTimestamp(campaignSummary.campaign.campaign_paused_on_ts)}
						</Alert>
					)}

					{/* Campaign Information Section */}
					<Stack direction="column" spacing={2} sx={{ p: 2, bgcolor: "background.paper", borderRadius: 1, border: "1px solid", borderColor: "divider" }}>
						<Typography variant="h6" fontWeight="bold">Campaign Information</Typography>
						<Grid2 container spacing={2}>
							{/* Basic Info */}
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Campaign UID:</Typography>
								<Typography variant="body1">{campaignSummary.campaign.campaign_id} <CopyButton text={campaignSummary.campaign.campaign_id} /></Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">User Email:</Typography>
								<Typography variant="body1">{campaignSummary.campaign.user_email} <CopyButton text={campaignSummary.campaign.user_email} /></Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Workspace:</Typography>
								<Typography variant="body1">{campaignSummary.campaign.workspace_name}</Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Archived:</Typography>
								<Chip label={campaignSummary.campaign.archived ? "Yes" : "No"} size="small" color={campaignSummary.campaign.archived ? "default" : "success"} />
							</Grid2>

							{/* Timestamps */}
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Created On:</Typography>
								<Typography variant="body1">{formatTimestamp(campaignSummary.campaign.created_on_ts)}</Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Started Running At:</Typography>
								<Typography variant="body1">{formatTimestamp(campaignSummary.campaign.started_running_at_ts)}</Typography>
							</Grid2>
							{campaignSummary.campaign.scheduled_start_datetime_ts && (
								<Grid2 size={{ xs: 12, md: 6 }}>
									<Typography variant="body2" color="text.secondary">Scheduled Start:</Typography>
									<Typography variant="body1">{formatTimestamp(campaignSummary.campaign.scheduled_start_datetime_ts)}</Typography>
								</Grid2>
							)}
							{campaignSummary.campaign.completed_at_ts && (
								<Grid2 size={{ xs: 12, md: 6 }}>
									<Typography variant="body2" color="text.secondary">Completed At:</Typography>
									<Typography variant="body1">{formatTimestamp(campaignSummary.campaign.completed_at_ts)}</Typography>
								</Grid2>
							)}
							{campaignSummary.campaign.cancelled_at_ts && (
								<Grid2 size={{ xs: 12, md: 6 }}>
									<Typography variant="body2" color="text.secondary">Cancelled At:</Typography>
									<Typography variant="body1">{formatTimestamp(campaignSummary.campaign.cancelled_at_ts)}</Typography>
								</Grid2>
							)}

							{/* Email Settings */}
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Sending Window:</Typography>
								<Typography variant="body1">{campaignSummary.campaign.from_time} - {campaignSummary.campaign.to_time}</Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Time Zone:</Typography>
								<Typography variant="body1">{campaignSummary.campaign.time_zone}</Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Daily Sending Limit per Domain:</Typography>
								<Typography variant="body1">{campaignSummary.campaign.daily_email_limit}</Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Open Tracking:</Typography>
								<Chip label={campaignSummary.campaign.open_tracking_enabled ? "Enabled" : "Disabled"} size="small" />
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Click Tracking:</Typography>
								<Chip label={campaignSummary.campaign.click_tracking_enabled ? "Enabled" : "Disabled"} size="small" />
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Contact List Verified:</Typography>
								<Chip label={campaignSummary.campaign.contact_list_verified ? "Yes" : "No"} size="small" />
							</Grid2>
							{(campaignSummary.campaign.emails_per_day ?? 0) > 0 && (
								<Grid2 size={{ xs: 12, md: 6 }}>
									<Typography variant="body2" color="text.secondary">Emails Per Day:</Typography>
									<Typography variant="body1">{campaignSummary.campaign.emails_per_day}</Typography>
								</Grid2>
							)}
							{campaignSummary.campaign.reply_to_address && (
								<Grid2 size={{ xs: 12, md: 6 }}>
									<Typography variant="body2" color="text.secondary">Reply To Address:</Typography>
									<Typography variant="body1">{campaignSummary.campaign.reply_to_address}</Typography>
								</Grid2>
							)}
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Unsubscribe Link:</Typography>
								<Chip label={campaignSummary.campaign.add_unsub_link ? "Enabled" : "Disabled"} size="small" color={campaignSummary.campaign.add_unsub_link ? "success" : "default"} />
							</Grid2>
							{campaignSummary.campaign.skip_days && campaignSummary.campaign.skip_days.length > 0 && (
								<Grid2 size={{ xs: 12 }}>
									<Typography variant="body2" color="text.secondary">Skip Days:</Typography>
									<Stack direction="row" spacing={1} flexWrap="wrap">
										{campaignSummary.campaign.skip_days.map((day, idx) => (
											<Chip key={idx} label={day} size="small" />
										))}
									</Stack>
								</Grid2>
							)}
							{campaignSummary.campaign.days_campaign_sent && Array.isArray(campaignSummary.campaign.days_campaign_sent) && campaignSummary.campaign.days_campaign_sent.length > 0 && (
								<Grid2 size={{ xs: 12 }}>
									<Typography variant="body2" color="text.secondary">Days Campaign Sent:</Typography>
									<Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>
										{campaignSummary.campaign.days_campaign_sent.map((day, idx) => (
											<Chip key={idx} label={day} size="small" color="success" />
										))}
									</Stack>
								</Grid2>
							)}
							{campaignSummary.campaign.days_campaign_not_sent && Array.isArray(campaignSummary.campaign.days_campaign_not_sent) && campaignSummary.campaign.days_campaign_not_sent.length > 0 && (
								<Grid2 size={{ xs: 12 }}>
									<Typography variant="body2" color="text.secondary">Days Campaign Not Sent:</Typography>
									<Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>
										{campaignSummary.campaign.days_campaign_not_sent.map((day, idx) => (
											<Chip key={idx} label={day} size="small" color="default" />
										))}
									</Stack>
								</Grid2>
							)}

							{/* Sending Domains */}
							{campaignSummary.campaign.sending_domains && campaignSummary.campaign.sending_domains.length > 0 && (
								<Grid2 size={{ xs: 12 }}>
									<Typography variant="body2" color="text.secondary">Sending Domains:</Typography>
									<Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>
										{campaignSummary.campaign.sending_domains.map((domain) => (
											<Chip
												key={domain.id}
												label={`${domain.subdomain} (${domain.warmup_percent}% warmup, ${domain.warmup_days_remaining}d left)`}
												size="small"
												color={domain.status === "verified" ? "success" : "default"}
											/>
										))}
									</Stack>
								</Grid2>
							)}

							{/* Contact Lists */}
							{campaignSummary.campaign.selected_contact_lists &&
								campaignSummary.campaign.selected_contact_lists.length > 0 && (
									<Grid2 size={{ xs: 12 }}>
										<Typography variant="body2" color="text.secondary">
											Contact Lists:
										</Typography>

										<Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>
											{campaignSummary.campaign.selected_contact_lists.map((list) => (
												<Chip
													key={list.uid}
													component={RouterLink}
													clickable
													to={urls["adminUserContactListDetails"]
														.replace(":userId", campaignSummary.campaign.user_id.toString())
														.replace(":contactListUID", list.uid)}
													avatar={
														<Avatar
															src={LogoMap[list.source]}
															alt={list.source}
															sx={{ width: 20, height: 20 }}
														/>
													}
													label={`${list.name} (${list.status})`}
													size="small"
													sx={{
														textDecoration: "none",
														color: "inherit",
													}}
												/>
											))}
										</Stack>
									</Grid2>
								)}
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Campaign Strategy Mode:</Typography>
								<Chip label={campaignSummary.campaign.scheduling_strategy_display} size="small" />
							</Grid2>						
						</Grid2>						
						<Grid2 size={{ xs: 12, md: 6 }}>
							<Typography variant="body2" color="text.secondary">Campaign Type:</Typography>
							<Typography variant="body1">{campaignSummary.campaign.campaign_type}</Typography>
						</Grid2>
						{campaignSummary.campaign.is_campaign_ab_cancelled &&
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="body2" color="text.secondary">Campaign A/B Auto-Cancelled:</Typography>
								<Typography variant="body1">{campaignSummary.campaign.is_campaign_ab_cancelled}</Typography>
							</Grid2>
						}
					</Stack>

					{/* Statistics Cards */}
					<Grid2 container spacing={3}>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<ContactMail />}
								heading="Total Contacts"
								value={campaignSummary.campaign.total_contacts}
								color="#2196f3"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<CalendarMonth />}
								heading="Total Schedules"
								value={campaignSummary.campaign.total_schedules}
								color="#ff9800"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<Send />}
								heading="Total Sent"
								value={campaignSummary.campaign.total_sent}
								color="#673ab7"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<Message />}
								heading="Total Replies"
								value={campaignSummary.campaign.total_replies}
								color="#009688"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<BarChart />}
								heading="Total Bounced"
								value={`${campaignSummary.campaign.total_bounced}${campaignSummary.campaign.bounce_rate ? ` (${campaignSummary.campaign.bounce_rate}%)` : ''}`}
								color="#3f51b5"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<Unsubscribe />}
								heading="Total Unsubscribe"
								value={campaignSummary.campaign.total_unsubscribe ?? 0}
								color="#ff5722"
							/>
						</Grid2>
						{campaignSummary.campaign.positive_replies !== undefined && (
							<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<Message />}
									heading="Positive Replies"
									value={campaignSummary.campaign.positive_replies}
									color="#4caf50"
								/>
							</Grid2>
						)}
						{campaignSummary.campaign.negative_replies !== undefined && (
							<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<Message />}
									heading="Negative Replies"
									value={campaignSummary.campaign.negative_replies}
									color="#f44336"
								/>
							</Grid2>
						)}
						{campaignSummary.campaign.neutral_replies !== undefined && (
							<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<Message />}
									heading="Neutral Replies"
									value={campaignSummary.campaign.neutral_replies}
									color="#9e9e9e"
								/>
							</Grid2>
						)}
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<VisibilityIcon />}
								heading="Opens"
								value={
									<Stack spacing={0}>
										<Typography variant="body2" fontWeight="bold">
											Total Open: {campaignSummary.campaign.total_opens}
										</Typography>

										<Typography variant="body2" fontWeight="bold">
											Unique Open: {campaignSummary.campaign.unique_opens}
										</Typography>
									</Stack>
								}
								color="#ff1744"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<AdsClickIcon />}
								heading="Clicks"
								value={
									<Stack spacing={0}>
										<Typography variant="body2" fontWeight="bold">
											Total Click: {campaignSummary.campaign.total_clicks}
										</Typography>

										<Typography variant="body2" fontWeight="bold">
											Unique Click: {campaignSummary.campaign.unique_clicks}
										</Typography>
									</Stack>
								}
								color="#ff1744"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<PeopleAltIcon />}
									heading="Total Leads Contacted"
									value={`${campaignSummary.campaign.leads_contacted} of ${campaignSummary.campaign.total_contacts}`}
									color="#f44336"
								/>
						</Grid2>
						{estEndDate && (
							<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<EventAvailableIcon />}
									heading="Campaign End Date"
									value={estEndDate}
									color="#f44336"
								/>
							</Grid2>
						)}
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<ReplyIcon />}
								heading="Reply Rate"
								value={`${campaignSummary.campaign.reply_rate ?? 0}%`}
								color="#4caf50"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<ReportIcon />}
								heading="Bounce Rate"
								value={`${campaignSummary.campaign.bounce_rate ?? 0}%`}
								color="#f44336"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<MarkEmailReadIcon />}
								heading="Open Rate"
								value={`${campaignSummary.campaign.open_rate ?? 0}%`}
								color="#2196f3"
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
							<StatCard
								icon={<TouchAppIcon />}
								heading="Click Rate"
								value={`${campaignSummary.campaign.click_rate ?? 0}%`}
								color="#9c27b0"
							/>
						</Grid2>
						{dailyLogSummary && (
							<>
								<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
									<StatCard
										icon={<HourglassBottom />}
										heading="Days Remaining"
										value={dailyLogSummary.days_remaining}
										color="#ff9800"
									/>
								</Grid2>
								<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
									<StatCard
										icon={<Dns />}
										heading="Total Domains"
										value={dailyLogSummary.total_domains}
										color="#9c27b0"
									/>
								</Grid2>
							</>
						)}
					</Grid2>
					{/* -------------- DAILY SENDING LOG -------------- */}
					<Stack direction={"column"} spacing={2}>
						<Typography variant={"h6"} fontWeight={"bold"}>Daily Sending Log:</Typography>
						<AdminCampaignDailyLog campaignUid={campaignUID || ""} />
					</Stack>
					{/* -------------- EMAIL MESSAGES -------------- */}
					<Stack direction={"column"} spacing={2}>
						<Typography variant={"h6"} fontWeight={"bold"}>Email Messages:</Typography>						
						<Box sx={{ height: "450px", width: "100%", overflow: "hidden" }}>
							<PaginatedServerSideDataTable
								columns={emailMessagesColumnDefs}
								paginationData={messagesQuery.data?.data}
								loading={messagesQuery.isLoading}
								onPageChange={(page) => setMessagesPage(page)}
								onPageSizeChange={(pageSize) => {
									setMessagesPageSize(pageSize);
									setMessagesPage(1); // Reset to first page when page size changes
								}}
								onSearchChange={(search) => {
									setMessagesSearch(search);
									setMessagesPage(1); // Reset to first page when search changes
								}}
								searchPlaceholder="Search messages..."
								columnLabels={emailMessagesColumnCustomizerLabel}
								actions={
										<GenericCsvExportButton
											endpoint={
												campaignType === "multi-variant"
													? "/admin/get-campaign-variants/"
													: "/admin/get-campaign-messages/"
											}
											queryParams={{
												campaign_uid: campaignUID,
												search: messagesSearch,
											}}
											columns={colDefsToCsvColumns(emailMessagesColumnDefs)}
											exportName={
												campaignType === "multi-variant"
													? "CampaignVariants"
													: "CampaignMessages"
											}											
											disabled={!campaignUID}
										/>
									}
							/>
						</Box>
					</Stack>
					{/* -------------- EMAIL Variant Analysis -------------- */}
					{ campaignType === "multi-variant" && (
						<Stack direction={"column"} spacing={2}>
							<Typography variant={"h6"} fontWeight={"bold"}>Email Variant Analysis:</Typography>							
							<Box sx={{ height: "450px", width: "100%", overflow: "hidden" }}>
								<PaginatedServerSideDataTable
									columns={variantAnalysisColumnDefs}
									paginationData={adminVariantAnalysisQuery.data?.data}
									loading={adminVariantAnalysisQuery.isLoading}
									onPageChange={(page) => setVariantPage(page)}
									onPageSizeChange={(pageSize) => {
										setVariantPageSize(pageSize);
										setVariantPage(1); // Reset to first page when page size changes
									}}
									onSearchChange={(search) => {
										setVariantSearch(search);
										setVariantPage(1); // Reset to first page when search changes
									}}
									searchPlaceholder="Search Variant..."
									columnLabels={VariantColumnCustomizerLabel}
									actions={<GenericCsvExportButton
											endpoint="/admin/campaign-variant-analysis/"
											queryParams={{ campaign_uid: campaignUID, search: variantSearch }}
											columns={colDefsToCsvColumns(variantAnalysisColumnDefs)}
											exportName="VariantAnalysis"
											filePrefix={campaignUID}
											disabled={!campaignUID}
										/>}
								/>
							</Box>
						</Stack>
					)}					
					{/* -------------- CONTACTS -------------- */}
					<Stack direction={"column"} spacing={2}>
						<Typography variant={"h6"} fontWeight={"bold"}>Contacts:</Typography>
						<Box sx={{ height: "600px", width: "100%", overflow: "hidden" }}>
							<PaginatedServerSideDataTable
								columns={contactsColumnDefs}
								paginationData={contactsQuery.data?.data}
								loading={contactsQuery.isLoading}
								onPageChange={(page) => setContactsPage(page)}
								onPageSizeChange={(pageSize) => {
									setContactsPageSize(pageSize);
									setContactsPage(1); // Reset to first page when page size changes
								}}
								onSearchChange={(search) => {
									setContactsSearch(search);
									setContactsPage(1); // Reset to first page when search changes
								}}
								searchPlaceholder="Search contacts..."
								columnLabels={contactsColumnCustomizerLabel}
								actions={
									<GenericCsvExportButton
										endpoint="/admin/get-campaign-contacts/"
										queryParams={{
											campaign_uid: campaignUID,
											search: contactsSearch,
										}}
										columns={colDefsToCsvColumns(contactsColumnDefs)}
										exportName="CampaignContacts"
										disabled={!campaignUID}
									/>
								}
							/>
						</Box>
					</Stack>
					{/* -------------- SCHEDULES -------------- */}
					<Stack direction={"column"} spacing={2}>
						<Typography variant={"h6"} fontWeight={"bold"}>Schedules:</Typography>
						<Grid2 container spacing={3}>
							<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<Send />}
									heading="Email Sent Yesterday"
									value={schedulesQuery.data?.data.summary.sent_yesterday}
									color="#2196f3"
								/>
							</Grid2>
							<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<Send />}
									heading="Sending Email Today"
									value={schedulesQuery.data?.data.summary.sending_today}
									color="#ff9800"
								/>
							</Grid2>
							<Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
								<StatCard
									icon={<Send />}
									heading="Email Sending Tomorrow"
									value={schedulesQuery.data?.data.summary.sending_tomorrow}
									color="#673ab7"
								/>
							</Grid2>
						</Grid2>
						<Box sx={{ height: "600px", width: "100%", overflow: "hidden" }}>
							<PaginatedServerSideDataTable
								columns={schedulesColumnDefs}
								paginationData={schedulesQuery.data?.data}
								loading={schedulesQuery.isLoading}
								onPageChange={(page) => setSchedulesPage(page)}
								onPageSizeChange={(pageSize) => {
									setSchedulesPageSize(pageSize);
									setSchedulesPage(1); // Reset to first page when page size changes
								}}
								onSearchChange={(search) => {
									setSchedulesSearch(search);
									setSchedulesPage(1); // Reset to first page when search changes
								}}
								searchPlaceholder="Search schedules..."
								columnLabels={schedulesColumnCustomizerLabel}
								actions={<GenericCsvExportButton
											endpoint="/admin/get-campaign-schedules/"
											queryParams={{ 
												campaign_uid: campaignUID, 
												search: schedulesSearch 
											}}
											columns={colDefsToCsvColumns(schedulesColumnDefs)}
											exportName="CampaignSchedules"
											filePrefix={campaignUID}
											disabled={!campaignUID}
										/>}
							/>
						</Box>
					</Stack>
					<Stack direction={"column"} spacing={2}>
						<Typography variant="h6">
							Bounces:
						</Typography>
						<Box sx={{ height: "600px", width: "100%", overflow: "hidden" }}>
							<PaginatedServerSideDataTable
								columns={bounceColumnDefs}
								paginationData={BouncesQuery.data?.data}
								loading={BouncesQuery.isLoading}
								onPageChange={(page) => setBouncesPage(page)}
								onPageSizeChange={(pageSize) => {
									setBouncesPageSize(pageSize);
									setBouncesPage(1);
								}}
								onSearchChange={(search) => {
									setBouncesSearch(search);
									setBouncesPage(1);
								}}
								onSortChange={handleSortChange}
								searchPlaceholder="Search Bounces..."
								columnLabels={BouncesColumnCustomizerLabel}
								actions={<GenericCsvExportButton
									endpoint="/admin/get-campaign-bounce-events-v2/"
									queryParams={{
										campaign_uid: campaignUID,
										workspace_id: String(campaignSummary?.campaign.workspace_id || ""),
										search: bouncesSearch,
									}}
									columns={colDefsToCsvColumns(bounceColumnDefs)}
									exportName="CampaignBounceEvents"
									disabled={!campaignUID || !(campaignSummary?.campaign.workspace_id)}
								/>}							
							/>
						</Box>
					</Stack>
					<Stack direction={"column"} spacing={2}>
						<Typography variant="h6">
							Auto Response:
						</Typography>
						<Box sx={{ height: "600px", width: "100%", overflow: "hidden" }}>
							<PaginatedServerSideDataTable
								columns={AutoResponseColumnDefs}
								paginationData={adminAutoResponseQuery.data?.data}
								loading={adminAutoResponseQuery.isLoading}
								onPageChange={(page) => setAutoResponsePage(page)}
								onPageSizeChange={(pageSize) => {
									setAutoResponsePageSize(pageSize);
									setAutoResponsePage(1);
								}}
								onSearchChange={(search) => {
									setAutoResponseSearch(search);
									setAutoResponsePage(1);
								}}
								onSortChange={handleSortChange}
								searchPlaceholder="Search Auto Response..."
								columnLabels={AutoResponseColumnCustomizerLabel}
								actions={
									<Stack direction="row" spacing={1.5} alignItems="center">
									<ExportAutoResponseCsvButton />
									</Stack>
								}
							/>
						</Box>
					</Stack>
					<Stack direction={"column"} spacing={2}>
						<Typography variant="h6">
							Auto Response Message:
						</Typography>
						<Box sx={{ height: "600px", width: "100%", overflow: "hidden" }}>
							<PaginatedServerSideDataTable
								columns={AutoResponseMessageColumnDefs}
								paginationData={adminAutoResponseMessageQuery.data?.data}
								loading={adminAutoResponseMessageQuery.isLoading}
								onPageChange={(page) => setAutoResponseMessagePage(page)}
								onPageSizeChange={(pageSize) => {
									setAutoResponseMessagePageSize(pageSize);
									setAutoResponseMessagePage(1);
								}}
								onSearchChange={(search) => {
									setAutoResponseMessageSearch(search);
									setAutoResponseMessagePage(1);
								}}
								onSortChange={handleSortChange}
								searchPlaceholder="Search Auto Response Message..."
								columnLabels={AutoResponseMessageColumnCustomizerLabel}
								actions={
									<Stack direction="row" spacing={1.5} alignItems="center">
									<ExportAutoResponseMessageCsvButton />
									</Stack>
								}
							/>
						</Box>
					</Stack>
					<Stack spacing={2} mt={3}>
						<Typography variant="h6">
							Campaign Replies:
						</Typography>

						<Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
							<TextField
								size="small"
								placeholder="Search replies..."
								value={repliesSearch}
								onChange={(e) => {
									setRepliesSearch(e.target.value);
									setRepliesPage(1);
								}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon fontSize="small" />
										</InputAdornment>
									),
								}}
								sx={{ width: 320 }}
							/>

							<GenericCsvExportButton
								endpoint="/admin/get-replies-campaign/"
								queryParams={{
									campaign_uid: campaignUID,
									workspace_id: campaignSummary?.campaign.workspace_id,
									search: repliesSearch,
								}}
								columns={repliesCsvColumns}
								exportName="CampaignReplies"
								disabled={!campaignUID || !campaignSummary?.campaign.workspace_id}
								transformResponse={(res) => {
									const repliesData = res?.data?.data?.replies || res?.data?.data || {};
									return Array.isArray(repliesData) 
										? repliesData 
										: Object.values(repliesData).flat();
								}}
							/>
						</Stack>
						{Object.keys(repliesQuery.data?.data?.replies || {}).length === 0 ? (
							<Box
								sx={{
									border: "1px dashed",
									borderColor: "divider",
									borderRadius: 2,
									p: 6,
									textAlign: "center",
									backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'background.paper' : '#FAFAFA',
								}}
							>
								<Typography
									variant="h6"
									color="text.secondary"
									gutterBottom
								>
									No replies found
								</Typography>

								<Typography
									variant="body2"
									color="text.secondary"
								>
									No campaign replies are available for this campaign.
								</Typography>
							</Box>
						) : 
						Object.entries(repliesQuery.data?.data?.replies || {}).map(
							([scheduleUID, replies]: any) => {

								const firstReply = replies[0];
								
								const displaySequence = firstReply?.sequence_number !== undefined 
									? Number(firstReply.sequence_number) + 1 
									: "?";

								const isMultiVariant = campaignType === "multi-variant";

								// Pre-compute the prefix string so the JSX stays clean
								const emailPrefixLabel = isMultiVariant
									? `Email ${displaySequence} - Variant ${firstReply?.variant_name || ""}:`
									: `Email ${displaySequence}:`;
									
								return (
									<Accordion
										key={scheduleUID}
										disableGutters
										sx={{
											border: "1px solid",
											borderColor: "divider",
											borderRadius: "12px !important",
											boxShadow: "none",
											overflow: "hidden",
											backgroundColor: "background.paper"
										}}
									>
										<AccordionSummary expandIcon={<ExpandMoreIcon />}>
											<Stack
												direction="row"
												alignItems="center"
												justifyContent="space-between"
												width="100%"
												pr={2}
											>
												<Stack spacing={0.5}>
													<Typography fontWeight={600}>
														<Box component="span" sx={{ color: "text.primary", marginRight: 0.5 }}>
															{emailPrefixLabel}
														</Box>
														Received {replies.length} Replies from{" "}
														{firstReply.sender_email}
													</Typography>

													<Typography
														variant="body2"
														color="text.secondary"
													>
														{format(
															new Date(firstReply.received_on),
															"h:mma, dd MMM yyyy"
														)}
													</Typography>
												</Stack>
											</Stack>
										</AccordionSummary>

										<AccordionDetails>
											<Stack spacing={2}>
												{replies.map((reply: any, index: number) => {

													const chip = getReplyChipColor(reply.reply_class);

													return (
														<Box
															key={reply.postal_id || index}
															sx={{
																display: "flex",
																justifyContent: "space-between",
																alignItems: "center",
																borderBottom: index !== replies.length - 1 ? "1px solid" : "none",
																borderBottomColor: "divider",
																pb: 2,
																mb: 2,
															}}
														>
															<Stack spacing={1} flex={1}>
																<Typography
																	fontStyle="italic"
																	sx={{
																		color: "text.primary",
																		fontSize: "15px",
																	}}
																>
																	{reply.plain_text_body?.slice(0, 180)}
																</Typography>

																<Stack
																	direction="row"
																	alignItems="center"
																	spacing={1}
																>
																	<Typography
																		variant="caption"
																		color="text.secondary"
																	>
																		{format(
																			new Date(reply.received_on),
																			"h:mma, dd MMM yyyy"
																		)}
																	</Typography>

																	<Chip
																		label={chip.label}
																		size="small"
																		sx={{
																			background: chip.bg,
																			color: chip.color,
																			fontWeight: 600,
																		}}
																	/>
																	{reply.postal_id && reply.postal_link && (
																		<Box 
																			component="a" 
																			href={reply.postal_link}
																			target="_blank" 
																			rel="noopener noreferrer"
																			onClick={(e) => e.stopPropagation()} // CRITICAL: Stops row container accordion from opening/closing
																			sx={{ 
																				marginLeft: 2, 
																				color: "primary.main", 
																				fontWeight: 600, 
																				textDecoration: "none",
																				display: "inline-flex",
																				alignItems: "center",
																				"&:hover": { 
																					textDecoration: "underline",
																					color: "primary.dark"
																				} 
																			}}
																		>
																			Postal #{reply.postal_id}
																		</Box>
																	)}
																</Stack>
															</Stack>

															<Button
																variant="outlined"
																size="small"
																onClick={() => {
																	setSelectedReply(reply);
																	setReplyDialogOpen(true);
																}}
															>
																View Reply
															</Button>
														</Box>
													);
												})}
											</Stack>
										</AccordionDetails>
									</Accordion>
								);
							}
						)}

						{Object.keys(repliesQuery.data?.data?.replies || {}).length > 0 && (
							<Box 
								display="flex" 
								flexDirection="row" 
								justifyContent="space-between" 
								alignItems="center" 
								mt={2}
							>
								{/* Left Side: Rows Selector & Range Info Label */}
								<Box display="flex" flexDirection="row" alignItems="center" gap={2}>
									<FormControl size="small" sx={{ minWidth: 100 }}>
										<InputLabel id="replies-rows-per-page-label">Rows per page</InputLabel>
										<Select
											labelId="replies-rows-per-page-label"
											value={repliesPageSize}
											label="Rows per page"
											onChange={(e) => {
												setRepliesPageSize(Number(e.target.value));
												setRepliesPage(1);
											}}
											sx={{ borderRadius: "8px", height: "40px" }}
										>
											<MenuItem value={10}>10</MenuItem>
											<MenuItem value={25}>25</MenuItem>
											<MenuItem value={50}>50</MenuItem>
										</Select>
									</FormControl>
									<Typography variant="body2" color="text.secondary">
										Showing {Object.keys(repliesQuery.data?.data?.replies || {}).length === 0 ? 0 : ((repliesPage - 1) * repliesPageSize) + 1}
										{' '}-{' '}
										{Math.min(repliesPage * repliesPageSize, repliesQuery.data?.data?.total_count || 0)}
										{' '}of{' '}
										{repliesQuery.data?.data?.total_count || 0}
									</Typography>
								</Box>

								{/* Right Side: Navigation controls */}
								<Pagination
									count={repliesQuery.data?.data?.total_pages || 1}
									page={repliesPage}
									onChange={(_, page) => setRepliesPage(page)}
									color="primary"
									showFirstButton
									showLastButton
									size="medium"
								/>
							</Box>
						)}
					</Stack>
					<Stack spacing={2} mt={3}>
						<Typography variant="h6">
							Campaign Open Events:
						</Typography>

						<Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
							<TextField
								size="small"
								placeholder="Search opens..."
								value={opensSearch}
								onChange={(e) => {
									setOpensSearch(e.target.value);
									setOpensPage(1);
								}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon fontSize="small" />
										</InputAdornment>
									),
								}}
								sx={{ width: 320 }}
							/>

							<GenericCsvExportButton
								endpoint="/admin/get-campaign-open-events-expand-v2/"
								queryParams={{
									campaign_uid: campaignUID,
									workspace_id: campaignSummary?.campaign.workspace_id,
									search: opensSearch,
								}}
								columns={openEventsCsvColumns}
								exportName={"CampaignOpens"}
								disabled={!campaignUID || !campaignSummary?.campaign.workspace_id}
								transformResponse={(res) => res?.data?.data?.events || []}
							/>
						</Stack>

						{(opensQuery.data?.data?.events || []).length === 0 ? (
							<Box
								sx={{
										border: "1px dashed",
										borderColor: "divider", 
										borderRadius: 2,
										p: 6,
										textAlign: "center",
										backgroundColor: (theme) => 
											theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#FAFAFA', 
									}}
							>
								<Typography variant="h6" color="text.secondary" gutterBottom>
									No open events found
								</Typography>
								<Typography variant="body2" color="text.secondary">
									No open statistics are available for this campaign yet.
								</Typography>
							</Box>
						) : (
							<Box 							
								sx={{ 
									border: "1px solid", 
									borderColor: "divider",
									borderRadius: "12px", 
									overflow: "hidden", 
									backgroundColor: "background.paper"
								}}								
							>
								{(opensQuery.data?.data?.events || []).map((event: any, index: number, arr: any[]) => {
									const isExpanded = !!expandedRows[event.contact_email];
									const timestamps = event.all_timestamps || [];

									const displaySequence = event.sequence_number !== undefined 
										? Number(event.sequence_number) + 1 
										: index + 1;

									// 1. Determine if we should show the multi-variant details
									const isMultiVariant = campaignType === "multi-variant";

									// 2. Build the title text dynamically based on the campaign mode
									const titleText = isMultiVariant 
										? `Email ${displaySequence} - Variant ${event.variant_name || ""}:`
										: `Email ${displaySequence}:`;

									return (
										<Box 
											key={event.contact_email} 
											sx={{ 
													borderBottom: index !== arr.length - 1 ? "1px solid" : "none",
													borderBottomColor: (theme) => 
														theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)'
												}}
										>
											{/* Main Interaction Container */}
											<Box
												onClick={() => {
													setExpandedRows((prev: any) => ({
														...prev,
														[event.contact_email]: !prev[event.contact_email],
													}));
												}}
												sx={{
													p: 2,
													px: 3,
													display: "flex",
													alignItems: "center",
													justifyContent: "space-between",
													cursor: "pointer",													
												}}
											>
												<Typography variant="body1" color="text.primary">													
													<Box component="span" sx={{ fontWeight: 700, marginRight: 1 }}>
														{titleText}
													</Box>
													<Box component="span" sx={{ fontWeight: 700 }}>{event.contact_email}</Box>
													{" opened your email "}
													<Box component="span" sx={{ fontWeight: 700 }}>{event.total_opens}</Box>
													{` time${event.total_opens > 1 ? "s" : ""} (latest at `}
													<Box component="span" sx={{ fontWeight: 700 }}>
														{format(new Date(event.latest_date), "d MMM, yy")}
													</Box>
													)

													{event.postal_id && event.postal_link && (
														<Box 
															component="a" 
															href={event.postal_link}
															target="_blank" 
															rel="noopener noreferrer"
															onClick={(e) => e.stopPropagation()} // CRITICAL: Stops row container accordion from opening/closing
															sx={{ 
																marginLeft: 2, 
																color: "primary.main", 
																fontWeight: 600, 
																textDecoration: "none",
																display: "inline-flex",
																alignItems: "center",
																"&:hover": { 
																	textDecoration: "underline",
																	color: "primary.dark"
																} 
															}}
														>
															Postal #{event.postal_id}
														</Box>
													)}
												</Typography>

												<IconButton size="small">
													{isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
												</IconButton>
											</Box>

											{/* Dropdown Container displaying historical milestones */}
											<Collapse in={isExpanded} timeout="auto" unmountOnExit>
												<Box sx={{ 
														backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'action.hover' : '#F9FAFB', 
														borderTop: "1px solid",
														borderTopColor: (theme) => 
															theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)'
													}}>
													{/* Instead of reversing arrays dynamically in render, we map backwards */}
													{timestamps.map((_: string, tIndex: number) => {
														// Accessing array items from end to start to match your "reverse" intent
														const reversedIndex = timestamps.length - 1 - tIndex;
														const timestamp = timestamps[reversedIndex];
														const countNum = reversedIndex + 1;

														return (
															<Box
																key={timestamp + reversedIndex}
																sx={{
																		py: 1.5,
																		pl: 6,
																		pr: 3,
																		borderBottom: tIndex !== timestamps.length - 1 ? "1px dashed" : "none",
																		borderBottomColor: (theme) => 
																			theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)',
																	}}
															>
																<Typography variant="body2" color="text.primary">
																	<Box component="span" sx={{ fontWeight: 700 }}>
																		{getOrdinalSuffix(countNum)} opened on:
																	</Box>
																	{` ${format(new Date(timestamp), "do MMM yyyy, hh:mm a")}`}
																</Typography>
															</Box>
														);
													})}
												</Box>
											</Collapse>
										</Box>
									);
								})}
							</Box>
						)}

						{/* Table Pagination Control Footer */}
						{(opensQuery.data?.data?.events || []).length > 0 && (
							<Box 
								display="flex" 
								flexDirection="row" 
								justifyContent="space-between" 
								alignItems="center" 
								mt={2}
							>
								{/* Left Side: Rows Selector & Range Info Label */}
								<Box display="flex" flexDirection="row" alignItems="center" gap={2}>
									<FormControl size="small" sx={{ minWidth: 100 }}>
										<InputLabel id="opens-rows-per-page-label">Rows per page</InputLabel>
										<Select
											labelId="opens-rows-per-page-label"
											value={opensPageSize}
											label="Rows per page"
											onChange={(e) => {
												setOpensPageSize(Number(e.target.value));
												setOpensPage(1);
											}}
											sx={{ borderRadius: "8px", height: "40px" }}
										>
											<MenuItem value={10}>10</MenuItem>
											<MenuItem value={25}>25</MenuItem>
											<MenuItem value={50}>50</MenuItem>
										</Select>
									</FormControl>
									<Typography variant="body2" color="text.secondary">
										Showing {(opensQuery.data?.data?.events || []).length === 0 ? 0 : ((opensPage - 1) * opensPageSize) + 1}
										{' '}-{' '}
										{Math.min(opensPage * opensPageSize, opensQuery.data?.data?.total_count || 0)}
										{' '}of{' '}
										{opensQuery.data?.data?.total_count || 0}
									</Typography>
								</Box>

								{/* Right Side: Navigation controls */}
								<Pagination
									count={opensQuery.data?.data?.total_pages || 1}
									page={opensPage}
									onChange={(_, page) => setOpensPage(page)}
									color="primary"
									showFirstButton
									showLastButton
									size="medium"
								/>
							</Box>
						)}
					</Stack>
					<Stack spacing={2} mt={5}>
						<Typography variant="h6" sx={{ fontWeight: 'bold' }}>
							Campaign Click Events:
						</Typography>

						<Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
							<TextField
								size="small"
								placeholder="Search clicks..."
								value={clicksSearch}
								onChange={(e) => {
									setClicksSearch(e.target.value);
									setClicksPage(1); 
								}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon fontSize="small" />
										</InputAdornment>
									),
								}}
								sx={{ width: 320 }}
							/>

							<GenericCsvExportButton
								endpoint="/admin/get-campaign-click-events-v2/"
								queryParams={{
									campaign_uid: campaignUID,
									workspace_id: campaignSummary?.campaign.workspace_id,
									search: clicksSearch,
								}}
								columns={clickEventsCsvColumns}
								exportName={"CampaignClicks"}
								disabled={!campaignUID || !campaignSummary?.campaign.workspace_id}
								transformResponse={(res) => res?.data?.data?.events || []}
							/>
						</Stack>

						{clickEvents.length === 0 ? (
							<Box
								sx={{
									border: "1px dashed",
									borderColor: "divider",
									borderRadius: 2,
									p: 6,
									textAlign: "center",
									backgroundColor: (theme) => 
										theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#FAFAFA',
								}}
							>
								<Typography variant="h6" color="text.secondary" gutterBottom>
									No click events found
								</Typography>
								<Typography variant="body2" color="text.secondary">
									No click statistics are available for this campaign yet.
								</Typography>
							</Box>
						) : (
							<Box 
								sx={{ 
									border: "1px solid", 
									borderColor: "divider", 
									borderRadius: "12px", 
									overflow: "hidden", 
									backgroundColor: "background.paper" 
								}}
							>
								{clickEvents.map((event: any, index: number) => {
									const clickKey = `click_${event.contact_email}_${event.sequence_number}`;
									const isExpanded = !!expandedRows[clickKey];
									
									const displaySequence = event.sequence_number !== undefined 
											? Number(event.sequence_number) + 1 
											: index + 1;

										// 1. Determine if we should show the multi-variant details
										const isMultiVariant = campaignType === "multi-variant";

										// 2. Build the title text dynamically based on the campaign mode
										const titleText = isMultiVariant 
											? `Email ${displaySequence} - Variant ${event.variant_name || ""}:`
											: `Email ${displaySequence}:`;

									return (
										<Box 
											key={clickKey} 
											sx={{ 
												borderBottom: index !== clickEvents.length - 1 ? "1px solid" : "none",
												borderBottomColor: (theme) => 
													theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)'
											}}
										>
											{/* Collapsible Header Panel */}
											<Box
												onClick={() => setExpandedRows(prev => ({ ...prev, [clickKey]: !prev[clickKey] }))}
												sx={{
													p: 2,
													px: 3,
													display: "flex",
													alignItems: "center",
													justifyContent: "space-between",
													cursor: "pointer",												
												}}
											>
												<Typography variant="body1" color="text.primary">
													<Box component="span" sx={{ fontWeight: 700, marginRight: 1 }}>
														{titleText}
													</Box>
													<Box component="span" sx={{ fontWeight: 700 }}>{event.contact_email}</Box>
													{" clicked on links "}
													<Box component="span" sx={{ fontWeight: 700 }}>{event.total_clicks}</Box>
													{` time${event.total_clicks > 1 ? "s" : ""} (latest at `}
													<Box component="span" sx={{ fontWeight: 700 }}>
														{event.latest_date ? format(new Date(event.latest_date), "d MMM, yy") : "N/A"}
													</Box>
													)
													{event.postal_id && event.postal_link && (
														<Box 
															component="a" 
															href={event.postal_link}
															target="_blank" 
															rel="noopener noreferrer"
															onClick={(e) => e.stopPropagation()} // CRITICAL: Stops row container accordion from opening/closing
															sx={{ 
																marginLeft: 2, 
																color: "primary.main", 
																fontWeight: 600, 
																textDecoration: "none",
																display: "inline-flex",
																alignItems: "center",
																"&:hover": { 
																	textDecoration: "underline",
																	color: "primary.dark"
																} 
															}}
														>
															Postal #{event.postal_id}
														</Box>
													)}
												</Typography>

												<IconButton size="small">
													{isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
												</IconButton>
											</Box>

											{/* Expanded Content Panel detailing clicked links & specific timestamps */}
											<Collapse in={isExpanded} timeout="auto" unmountOnExit>
												<Box sx={{ 
														p: 3, 
														backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'action.hover' : '#F9FAFB', 
														borderTop: "1px solid", 
														borderTopColor: "divider",
														pl: 6 
													}}>
													{(event.links || []).map((link: any, linkIdx: number) => (
														<Box key={linkIdx} sx={{ mb: linkIdx !== event.links.length - 1 ? 2 : 0 }}>
															<Typography variant="body2" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
																URL: <Link href={link.url} target="_blank" rel="noopener">{link.url}</Link> ({link.count} click{link.count > 1 ? 's' : ''})
															</Typography>
															
															{/* Timestamp Sub-List */}
															<Box sx={{ mt: 1, pl: 2 }}>
																{(link.timestamps || []).map((ts: string, tsIdx: number) => {
																	// Fallback inline helper if getOrdinalSuffix isn't imported global
																	const pr = new Intl.PluralRules('en-US', { type: 'ordinal' });
																	const suffixes = new Map([['one', 'st'], ['two', 'nd'], ['few', 'rd'], ['other', 'th']]);
																	const rule = pr.select(tsIdx + 1);
																	const suffix = suffixes.get(rule);
																	const ordinal = `${tsIdx + 1}${suffix}`;

																	return (
																		<Typography key={tsIdx} variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
																			<Box component="span" sx={{ fontWeight: 'bold' }}>{ordinal} clicked on:</Box>{" "}
																			{format(new Date(ts), "do MMM yyyy, hh:mm a")}
																		</Typography>
																	);
																})}
															</Box>
														</Box>
													))}
												</Box>
											</Collapse>
										</Box>
									);
								})}
							</Box>
						)}

						{/* Unified Footer Pagination Layout Matching the Main Data Table Setup */}
						{clickEvents.length > 0 && (
							<Box 
								display="flex" 
								flexDirection="row" 
								justifyContent="space-between" 
								alignItems="center" 
								mt={2}
							>
								<Box display="flex" flexDirection="row" alignItems="center" gap={2}>
									<FormControl size="small" sx={{ minWidth: 100 }}>
										<InputLabel id="clicks-rows-per-page-label">Rows per page</InputLabel>
										<Select
											labelId="clicks-rows-per-page-label"
											value={clicksPageSize}
											label="Rows per page"
											onChange={(e) => {
												setClicksPageSize(Number(e.target.value));
												setClicksPage(1);
											}}
											sx={{ borderRadius: "8px", height: "40px" }}
										>
											<MenuItem value={10}>10</MenuItem>
											<MenuItem value={25}>25</MenuItem>
											<MenuItem value={50}>50</MenuItem>
										</Select>
									</FormControl>
									<Typography variant="body2" color="text.secondary">
										Showing {clickEvents.length === 0 ? 0 : ((clicksPage - 1) * clicksPageSize) + 1}
										{' '}-{' '}
										{Math.min(clicksPage * clicksPageSize, clicksTotalCount)}
										{' '}of{' '}
										{clicksTotalCount}
									</Typography>
								</Box>

								<Pagination
									count={clicksTotalPages}
									page={clicksPage}
									onChange={(_, page) => setClicksPage(page)}
									color="primary"
									showFirstButton
									showLastButton
									size="medium"
								/>
							</Box>
						)}
					</Stack>
					{/* -------------- Manual Email Sent -------------- */}
					<Stack direction={"column"} spacing={2}>
						<Typography variant={"h6"} fontWeight={"bold"}>Manual Email Sent:</Typography>						
						<Box sx={{ height: "450px", width: "100%", overflow: "hidden" }}>
							<PaginatedServerSideDataTable
								columns={manualEmailSentColumnDefs}
								paginationData={manualEmailSentQuery.data?.data}
								loading={manualEmailSentQuery.isLoading}
								onPageChange={(page) => setManualEmailPage(page)}
								onPageSizeChange={(pageSize) => {
									setManualEmailPageSize(pageSize);
									setManualEmailPage(1);
								}}
								onSearchChange={(search) => {
									setManualEmailPageSearch(search);
									setManualEmailPage(1);
								}}
								searchPlaceholder="Search messages..."
								columnLabels={manualEmailSentColumnCustomizerLabel}
								actions={
									<GenericCsvExportButton
										endpoint="/admin/manual-email-sent/"
										queryParams={{
											campaign_uid: campaignUID,
											search: manualEmailPageSearch,
										}}
										columns={colDefsToCsvColumns(manualEmailSentColumnDefs)}
										exportName="CampaignManualEmailSent"
										disabled={!campaignUID}
									/>
								}
							/>
						</Box>
					</Stack>
				</Stack>
				{/* Campaign Settings Modal */}
				{campaignSummary && (
					<CampaignSettingsModal
						open={openSettingsModal}
						campaignSummary={campaignSummary}
						settingsForm={settingsForm}
						onClose={() => setOpenSettingsModal(false)}
						onSave={(settings) => updateCampaignSettingsMutation.mutate(settings)}
						isSaving={updateCampaignSettingsMutation.isPending}
					/>
				)}

				<SendEmailDialog
					open={openSendDialog}
					onClose={() => setOpenSendDialog(false)}
					workspaceId={campaignSummary.campaign.workspace_id}
					campaignUID={campaignSummary.campaign.campaign_id}
					messageUID={selectedMessageUID} // This will dynamically pass either the variant UID or message UID
				/>
				<ReplyViewDialog
					open={replyDialogOpen}
					onClose={() => setReplyDialogOpen(false)}
					selectedReply={selectedReply}
					getReplyChipColor={getReplyChipColor}
				/>
			</Stack>
		)
	} else {
		// Ideally it should not reach here.
		return <></>
	}
}

// Campaign Settings Modal Component
function CampaignSettingsModal(props: {
	open: boolean;
	campaignSummary: CampaignSummaryData;
	settingsForm: {
		daily_email_limit: number;
		from_time: string;
		to_time: string;
		time_zone: string;
		reply_to_address: string;
		archived: boolean;
		esp_send_google: boolean;
		esp_send_microsoft: boolean;
		esp_send_zoho: boolean;
		esp_send_other: boolean;
		bot_filter_enabled: boolean;
		bot_filter_google: boolean;
		bot_filter_microsoft: boolean;
		bot_filter_zoho: boolean;
		bot_filter_other: boolean;
		skip_unverified_emails: boolean,
		skip_dangerous_emails: boolean,
		skip_disposable_emails: boolean,
		skip_catchall_emails: boolean,
		skip_full_inbox_emails: boolean,
		skip_invalid_emails: boolean,
		skip_unverifiable_emails: boolean,
		skip_webmail_emails: boolean,
		send_to_skipped_emails: boolean,
	};
	onClose: () => void;
	onSave: (settings: any) => void;
	isSaving: boolean;
}) {
	const [formData, setFormData] = useState(props.settingsForm);

	// Update form data when modal opens or campaign data changes
	useEffect(() => {
		setFormData(props.settingsForm);
	}, [props.settingsForm, props.open]);

	const handleChange = (field: string, value: any) => {
		setFormData(prev => ({ ...prev, [field]: value }));
	};

	const handleSave = () => {
		if (!isValidCampaignDailyLimit(formData.daily_email_limit)) return;
		props.onSave(formData);
	};

	// Common timezones for dropdown
	const commonTimezones = [
		"America/New_York",
		"America/Chicago",
		"America/Denver",
		"America/Los_Angeles",
		"America/Phoenix",
		"Europe/London",
		"Europe/Paris",
		"Europe/Berlin",
		"Asia/Tokyo",
		"Asia/Shanghai",
		"Asia/Kolkata",
		"Australia/Sydney",
		"UTC",
	];

	const campaign = props.campaignSummary?.campaign;
    const verificationLists = campaign?.email_verification_contact_lists || [];
    const summary = campaign?.verification_summary || {};
    const totalContacts = summary.contacts_uploaded ?? campaign?.total_contacts ?? 0;
	const isCampaignCreated = campaign?.status === "created";

    const verificationToggleOptions = [
		{
            key: "send_to_safe" as const,
            label: "Send to Safe Emails",
            description: "Emails verified as deliverable and safe.",
            count: summary.contacts_after_verification ?? 0,
            isSafe: true,
        },
        {
            key: "skip_dangerous_emails" as const,
            label: "Send to Unsafe Emails",
            description: "Emails categorized as risky or deliverable with high bounce probability.",
            count: summary.dangerous_emails ?? 0,
        },
        {
            key: "skip_disposable_emails" as const,
            label: "Send to Temporary Emails",
            description: "Disposable domain email addresses.",
            count: summary.disposable_emails ?? 0,
        },
        {
            key: "skip_catchall_emails" as const,
            label: "Send to Catch All Emails",
            description: "Domains configured to accept all incoming mail regardless of local part.",
            count: summary.catch_all_emails ?? 0,
        },
        {
            key: "skip_full_inbox_emails" as const,
            label: "Send to Inbox Full Emails",
            description: "Mailboxes that have exceeded their storage quota.",
            count: summary.full_inbox_emails ?? 0,
        },
        {
            key: "skip_invalid_emails" as const,
            label: "Send to Invalid Emails",
            description: "Non-existent or malformed email addresses.",
            count: summary.invalid_emails ?? 0,
        },
        {
            key: "skip_unverifiable_emails" as const,
            label: "Send to Unable to Verify Emails",
            description: "Mail servers that timed out or refused status verification.",
            count: summary.unverifiable_emails ?? 0,
        },
        {
            key: "skip_webmail_emails" as const,
            label: "Send to Unverified Webmail",
            description: "Free webmail addresses that could not be fully verified.",
            count: summary.webmail_emails ?? 0,
        },
    ];

	return (
		<Dialog
			open={props.open}
			onClose={props.onClose}
			maxWidth="md"
			fullWidth
		>
			<DialogTitle>
				Edit Campaign Settings
				<Typography variant="caption" display="block" color="text.secondary">
					Campaign: {props.campaignSummary.campaign.name}
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Stack spacing={3} sx={{ mt: 1 }}>
					{/* Daily Email Limit */}
					<TextField
						label="Daily sending limit per domain"
						type="number"
						fullWidth
						value={formData.daily_email_limit}
						onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => handleChange('daily_email_limit', Number(e.target.value))}
						error={!isValidCampaignDailyLimit(formData.daily_email_limit)}
						helperText={isValidCampaignDailyLimit(formData.daily_email_limit) ? "Up to 100 daily emails per domain for this campaign." : "Enter a whole number between 1 and 100."}
						inputProps={{ min: CAMPAIGN_DAILY_LIMIT_MIN, max: CAMPAIGN_DAILY_LIMIT_MAX }}
					/>

					{/* Time Window */}
					<Grid2 container spacing={2}>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextField
								label="From Time"
								type="time"
								fullWidth
								value={formData.from_time}
								onChange={(e) => handleChange('from_time', e.target.value)}
								helperText="Start of sending window"
								InputLabelProps={{ shrink: true }}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextField
								label="To Time"
								type="time"
								fullWidth
								value={formData.to_time}
								onChange={(e) => handleChange('to_time', e.target.value)}
								helperText="End of sending window"
								InputLabelProps={{ shrink: true }}
							/>
						</Grid2>
					</Grid2>

					{/* Timezone */}
					<TextField
						label="Time Zone"
						select
						fullWidth
						value={formData.time_zone}
						onChange={(e) => handleChange('time_zone', e.target.value)}
						helperText="Timezone for email sending"
					>
						{commonTimezones.map((tz) => (
							<MenuItem key={tz} value={tz}>
								{tz}
							</MenuItem>
						))}
					</TextField>

					{/* Reply To Address */}
					<TextField
						label="Reply To Address"
						type="email"
						fullWidth
						value={formData.reply_to_address}
						onChange={(e) => handleChange('reply_to_address', e.target.value)}
						helperText="Email address where replies should go (optional)"
						placeholder="reply@example.com"
					/>

					{/* Archived Status */}
					<TextField
						label="Archived Status"
						select
						fullWidth
						value={formData.archived ? "true" : "false"}
						onChange={(e) => handleChange('archived', e.target.value === "true")}
						helperText="Archive this campaign to hide it from active campaigns"
					>
						<MenuItem value="false">Active</MenuItem>
						<MenuItem value="true">Archived</MenuItem>
					</TextField>
					
					<Divider sx={{ my: 1 }} />

                    {/* Email Verification Settings Section */}
                    {(campaign?.email_verification_status === "completed" || campaign?.email_verification_status === "skipped") && campaign?.enable_contact_verification && (
                        <Stack spacing={2}>
                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    Email Verification Settings
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Configure which email verification categories to include in email sends.
                                </Typography>
                            </Box>

                            {/* Lock Warning specifically scoped to Email Verification Settings when campaign status is not "created" */}
                            {!isCampaignCreated && (
                                <Alert severity="warning">
                                    These settings are locked because the campaign's schedule has already been generated.
                                </Alert>
                            )}

                            {/* Render contact list summary card ONLY when multiple lists exist */}
                            {verificationLists.length > 1 && (
                                <Paper variant="outlined" sx={{ p: 2, bgcolor: "action.hover", borderRadius: 2 }}>
                                    <Typography variant="caption" fontWeight="bold" display="block">
                                        Contact Lists Used:
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
                                        Verification statistics calculated across selected lists.
                                    </Typography>

                                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
                                        {verificationLists.slice(0, 3).map((list) => {
                                            const displayName =
                                                list.name.length > 17 ? `${list.name.slice(0, 17)}...` : list.name;
                                            return (
                                                <Tooltip key={list.uid} title={`List Name: ${list.name}`}>
                                                    <Paper
                                                        variant="outlined"
                                                        sx={{
                                                            p: 1,
                                                            px: 1.5,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 1,
                                                            bgcolor: "background.paper",
                                                            borderRadius: 1.5,
                                                        }}
                                                    >
                                                        <Box flex={1}>
                                                            <Typography variant="caption" fontWeight="bold" display="block">
                                                                {displayName}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary">
                                                                Total Contacts: {list.contacts_count}
                                                            </Typography>
                                                        </Box>
                                                    </Paper>
                                                </Tooltip>
                                            );
                                        })}

                                        {verificationLists.length > 3 && (
                                            <Chip
                                                label={`+${verificationLists.length - 3} more`}
                                                size="small"
                                                variant="outlined"
                                            />
                                        )}
                                    </Stack>
                                </Paper>
                            )}

                            <Stack spacing={1}>
                                {verificationToggleOptions.map((option) => {
                                    const isSafeOption = option.isSafe;
                                    const isDisabled = isSafeOption || !isCampaignCreated;
                                    const isChecked = isSafeOption ? true : !formData[option.key as keyof typeof formData];

                                    return (
                                        <Paper
                                            key={option.key}
                                            variant="outlined"
                                            sx={{
                                                p: 1.5,
                                                px: 2,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                borderRadius: 2,
                                                opacity: isDisabled ? 0.6 : 1,
                                            }}
                                        >
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <Switch
                                                    checked={isChecked}
                                                    onChange={(e) => !isSafeOption && handleChange(option.key, !e.target.checked)}
                                                    disabled={isDisabled}
                                                    size="small"
                                                />
                                                <Typography variant="body2" fontWeight="medium">
                                                    {option.label}
                                                </Typography>
                                                <Tooltip title={option.description} placement="top">
                                                    <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.secondary", cursor: "pointer" }} />
                                                </Tooltip>
                                            </Box>

                                            <Typography variant="caption" color="text.secondary" fontWeight="medium">
                                                Total: {option.count}/{totalContacts}
                                            </Typography>
                                        </Paper>
                                    );
                                })}
                            </Stack>
                        </Stack>
                    )}

					{/* ESP Sending */}
					<Box>
						<Typography variant="subtitle2">ESP Sending</Typography>
						<Typography variant="caption" color="text.secondary">
							Choose which email providers this campaign sends to. Leads on a provider that is switched off are
							skipped and never scheduled.
						</Typography>
						{props.campaignSummary.campaign.esp_settings_locked && (
							<Typography variant="caption" display="block" color="warning.main" sx={{ mt: 0.5 }}>
								These settings cannot be changed because the campaign schedule has already been generated.
							</Typography>
						)}
						<FormGroup sx={{ mt: 1 }}>
							{ESP_PROVIDERS.map(({field, label}) => (
								<FormControlLabel
									key={field}
									control={
										<Switch
											checked={formData[field]}
											onChange={(e) => handleChange(field, e.target.checked)}
											disabled={props.campaignSummary.campaign.esp_settings_locked}
										/>
									}
									label={
										<Box display="flex" alignItems="center" justifyContent="space-between" gap={2} width="100%">
											<Typography variant="body2">{label}</Typography>
											<Stack alignItems="flex-end">
												<Typography variant="caption" color="text.secondary">
													Total: {props.campaignSummary.campaign.esp_summary?.providers?.[field] ?? 0}/{props.campaignSummary.campaign.esp_summary?.total ?? 0}
												</Typography>
												{!formData[field] && (props.campaignSummary.campaign.esp_summary?.providers?.[field] ?? 0) > 0 && (
													<Typography variant="caption" color="warning.main">
														Skipped: {props.campaignSummary.campaign.esp_summary.providers[field]}
													</Typography>
												)}
											</Stack>
										</Box>
									}
									sx={{ alignItems: "center", width: "100%", m: 0, py: 0.5, ".MuiFormControlLabel-label": { flex: 1 } }}
								/>
							))}
						</FormGroup>
					</Box>

					<Divider/>

					<Box>
						<Typography variant="subtitle2">Bot Filter Settings</Typography>
						<Typography variant="caption" color="text.secondary" display="block">
							Choose which email providers bot filtering applies to. The detection window for each
							provider is set platform-wide under Email settings.
						</Typography>
						<FormControlLabel
							control={
								<Switch
									checked={formData.bot_filter_enabled}
									onChange={(event) => handleChange("bot_filter_enabled", event.target.checked)}
								/>
							}
							label="Enable Bot Filtering"
						/>
						{formData.bot_filter_enabled && (
							<FormGroup sx={{ mt: 1 }}>
								{ESP_PROVIDERS.map(({botFilterField, label}) => (
									<FormControlLabel
										key={botFilterField}
										control={
											<Switch
												checked={formData[botFilterField]}
												onChange={(event) => handleChange(botFilterField, event.target.checked)}
											/>
										}
										label={label}
									/>
								))}
							</FormGroup>
						)}
					</Box>

					{/* Current Campaign Status Info */}
					<Alert severity="info">
						<Typography variant="body2" fontWeight="bold">Current Campaign Status: {props.campaignSummary.campaign.status}</Typography>
						<Typography variant="caption">
							Note: Only safe fields can be updated. Campaign structure (emails, contacts, domains) cannot be modified here.
						</Typography>
					</Alert>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ px: 3, py: 2 }}>
				<Button
					onClick={props.onClose}
					disabled={props.isSaving}
				>
					Cancel
				</Button>
				<Button
					variant="contained"
					onClick={handleSave}
					disabled={props.isSaving || !isValidCampaignDailyLimit(formData.daily_email_limit)}
					startIcon={props.isSaving ? undefined : <Edit />}
				>
					{props.isSaving ? "Saving..." : "Save Changes"}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

function ViewReply(props: {
	replyFrom: string,
	s3key: string,
}) {
	const { userId, campaignUID } = useParams();
	const [open, setOpen] = React.useState(false);
	const [replyMessage, setReplyMessage] = React.useState("");

	// Query to fetch reply email message.
	const replyMessageQuery = useQuery({
		queryKey: ["replyMessageQuery", props.replyFrom, props.s3key],
		queryFn: () => {
			const params = new URLSearchParams({
				user_id: userId || "",
				campaign_uid: campaignUID || "",
				key: props.s3key,
			});
			return authenticateAndFetchData(`/admin/get-reply-email-message/?${params.toString()}`);
		},
		gcTime: 5000,
		retry: retryFn,
		refetchOnWindowFocus: false,
	});
	useEffect(() => {
		if (replyMessageQuery.data) {
			setReplyMessage(replyMessageQuery.data.data["message"]);
		}
	}, [replyMessageQuery.data]);

	const handleClickOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	if (replyMessageQuery.isLoading) {
		return (
			<PageLoading />
		)

	} else {
		return (
			<React.Fragment>
				<Button onClick={handleClickOpen} sx={{ marginLeft: "-2px" }} >
					View Reply
				</Button>
				<BootstrapDialog
					onClose={handleClose}
					aria-labelledby="view-reply-dialog"
					open={open}
				>
					<DialogTitle sx={{ m: 0, p: 2 }} id="view-reply-dialog">
						Reply from <b>{props.replyFrom}</b>
					</DialogTitle>
					<DialogContent dividers>
						<Typography gutterBottom>
							<pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{replyMessage}</pre>
						</Typography>
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={handleClose}>
							Close
						</Button>
					</DialogActions>
				</BootstrapDialog>
			</React.Fragment>
		);
	}
}

function SendEmailDialog({ open, onClose, workspaceId, campaignUID, messageUID }: { open: boolean, onClose: () => void, workspaceId: number, campaignUID: string, messageUID: string}) {
	const { enqueueSnackbar } = useSnackbar();
		
	const [targetEmails, setTargetEmails] = useState("");
	
	const sendEmailMutation = useMutation({
		mutationKey: ["sendEmailMutation"],
		mutationFn: (payload: any) => authenticateAndPostData("/admin/send-campaign-test-email/", payload),
		gcTime: 0,
		retry: retryFn,
		onSuccess: (response) => {
			enqueueSnackbar("Test email sent successfully", {
				variant: "success"
			});

			setTargetEmails("");

			onClose();
		},  
		onError: (error: ApiRequestFailed) => {
			console.error(error);
			enqueueSnackbar(error.data.message || "Failed to send", { variant: "error" });
		}
	});

	const handleSend = () => {
		if (!targetEmails) {
			enqueueSnackbar("Please fill in all required fields", { variant: "warning" });
			return;
		}		
		sendEmailMutation.mutate({
			workspace_id: workspaceId,
			uid: campaignUID,
			campaign_message_uid: messageUID,
			test_email_targets: targetEmails.split(",").map(e => e.trim()),		
		});
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<Typography variant="h6">Send Campaign Test Email</Typography>
				<IconButton onClick={onClose}><CloseIcon /></IconButton>
			</DialogTitle>
			<Divider />
			<DialogContent>
				<Stack spacing={2.5} sx={{ mt: 1 }}>					
					<TextField
						label="Recipient Emails"
						placeholder="email1@test.com, email2@test.com"
						fullWidth
						required
						value={targetEmails}
						onChange={(e) => setTargetEmails(e.target.value)}
					/>

				</Stack>
			</DialogContent>
			<DialogActions sx={{ p: 2.5 }}>
				<Button onClick={onClose} color="inherit">Cancel</Button>
				<Button 
					variant="contained" 
					onClick={handleSend}
					disabled={sendEmailMutation.isPending}
				>
					{sendEmailMutation.isPending ? <CircularProgress size={24} /> : "Send Email"}
				</Button>
			</DialogActions>
		</Dialog>
	);
}  


interface ReplyViewDialogProps {
	open: boolean;
	onClose: () => void;
	selectedReply: any;
	getReplyChipColor: (replyClass: string) => {
		label: string;
		bg: string;
		color: string;
	};
}

function ReplyViewDialog({
	open,
	onClose,
	selectedReply,
	getReplyChipColor,
}: ReplyViewDialogProps) {

	const chip = selectedReply
		? getReplyChipColor(selectedReply.reply_class)
		: null;

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="md"
			fullWidth
			keepMounted={false}
			transitionDuration={150}
			PaperProps={{
				sx: {
					borderRadius: 2,
					overflow: "hidden",
					width: "82%",
					maxWidth: "980px",
					height: "78vh",
				},
			}}
		>
			{/* HEADER */}
			<Box
				sx={{
					display: "flex",
					alignItems: "flex-start",
					justifyContent: "space-between",
					p: 3,
					borderBottom: "1px solid #E5E7EB",
					gap: 2,
				}}
			>
				<Stack direction="row" spacing={2} flex={1} minWidth={0}>
					<Box
						sx={{
							width: 48,
							height: 48,
							borderRadius: "50%",
							background: "#818CF8",
							color: "#fff",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontWeight: 700,
							fontSize: 22,
							flexShrink: 0,
						}}
					>
						{selectedReply?.sender_email?.[0]?.toUpperCase()}
					</Box>

					<Box sx={{ minWidth: 0 }}>
						<Typography
							fontWeight={700}
							fontSize={18}
							sx={{
								wordBreak: "break-word",
							}}
						>
							{selectedReply?.sender_email}
						</Typography>

						<Typography
							color="text.secondary"
							sx={{
								wordBreak: "break-word",
							}}
						>
							to: {selectedReply?.recipient}
						</Typography>
					</Box>
				</Stack>

				<Stack
					alignItems="flex-end"
					spacing={1}
					sx={{
						minWidth: "fit-content",
					}}
				>
					{chip && (
						<Chip
							label={chip.label}
							size="small"
							sx={{
								background: chip.bg,
								color: chip.color,
								fontWeight: 600,
							}}
						/>
					)}

					<Typography
						variant="body2"
						color="text.secondary"
						textAlign="right"
					>
						Reply Received on{" "}
						{selectedReply?.received_on &&
							format(
								new Date(selectedReply.received_on),
								"h:mm a, do MMM yyyy"
							)}
					</Typography>
				</Stack>
			</Box>

			{/* BODY */}
			<DialogContent
				sx={{
					p: 0,
					overflowX: "hidden",
					overflowY: "auto",
				}}
			>
				<Box
					sx={{
						p: 2.5,
						fontSize: "15px",
						lineHeight: 1.7,
						color: "#374151",
						wordBreak: "break-word",

						"& img": {
							maxWidth: "100%",
						},

						"& blockquote": {
							borderLeft: "3px solid #D1D5DB",
							marginLeft: 0,
							paddingLeft: "14px",
							color: "#6B7280",
						},
					}}
					dangerouslySetInnerHTML={{
						__html:
							selectedReply?.html_body ||
							selectedReply?.plain_text_body ||
							"No reply content",
					}}
				/>
			</DialogContent>

			<DialogActions
				sx={{
					px: 3,
					py: 2,
					borderTop: "1px solid #E5E7EB",
				}}
			>
				<Button onClick={onClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
}
